import React from "react";
import Header from "../../components/Header";
import { getAuth, onAuthStateChanged, signOut } from 'firebase/auth';
import { getDatabase, ref, child, get, onValue, update, set, push, remove } from "firebase/database";
import CodeMirror from "react-codemirror";
import "./Coding.css";
import "./dracula.css";
import VideoChatLiveKit from "../../components/VideoChatLiveKit";
import ControlPanel from "../../components/ControlPanel";
import Eval from "../../components/Eval";
import { RemoveScroll } from "react-remove-scroll";
import ReactGA from "react-ga4";
import { Resizable } from "re-resizable";
import Hotkeys from 'react-hot-keys';
import History from '../../components/History';
import Card from "../../components/Card";
import { IconContext } from "react-icons";
import { CiLogin, CiLogout } from "react-icons/ci";
import { FiShare2 } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import io from "socket.io-client";
import { Member, RemoteCursor, RemoteSelection, CursorPosition, TextSelection } from "../../types";
import LiveKitAgent from "../../components/LiveKitAgent";
import TabBar from "../../components/TabBar";
import DiagramView from "../../components/DiagramView";
import { diagramDataToText } from "../../lib/diagramToText";

require("codemirror/lib/codemirror.css");
require("codemirror/mode/javascript/javascript");
require("codemirror/mode/ruby/ruby");
require("codemirror/mode/python/python");
require("codemirror/mode/swift/swift");
require("codemirror/mode/clike/clike");
require("codemirror/mode/go/go");
require("codemirror/mode/php/php");
require("codemirror/mode/r/r");
require("codemirror/mode/clike/clike");
require("codemirror/addon/display/placeholder");
require("codemirror/addon/edit/matchbrackets");
require("codemirror/addon/edit/matchtags");
require("codemirror/addon/edit/closebrackets");
require("codemirror/addon/edit/closetag");

function initializeAnalytics() {
  ReactGA.initialize("G-GC90QV1WJF");
  ReactGA.send({ hitType: "pageview", page: "/Coding" });
}

function CodingPageWrapper(props) {
  const navigate = useNavigate();
  return <CodingPage {...props} navigate={navigate} />;
}

// Utility function to get the correct base URL for API calls
const getBaseURL = () => {
  // If we are in production, prioritize the production URL unless a non-localhost override is provided
  if (process.env.NODE_ENV === 'production') {
    if (process.env.REACT_APP_BACKEND_URL && !process.env.REACT_APP_BACKEND_URL.includes('localhost')) {
      return process.env.REACT_APP_BACKEND_URL;
    }
    return 'https://interview-sandbox-production.up.railway.app';
  }

  // If REACT_APP_BACKEND_URL is set (e.g., for ngrok), use it
  if (process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL;
  }

  // In development, check if we're accessing from a different device
  const hostname = window.location.hostname;
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:8000';
  } else {
    // Use the same hostname/IP but port 8000 for backend
    return `http://${hostname}:8000`;
  }
};

class CodingPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      code: "Loading...",
      loading: false,
      mode: "python",
      language_id: 71,
      language: [
        {
          id: 0,
          language_id: 63,
          title: " JS",
          mode: "javascript",
          fa_icon: "FaJsSquare",
          selected: false,
          key: "language",
        },
        {
          id: 1,
          language_id: 71,
          title: " Python",
          mode: "python",
          fa_icon: "FaPython",
          selected: false,
          key: "language",
        },
        {
          id: 2,
          language_id: 72,
          title: " Ruby",
          mode: "ruby",
          fa_icon: "FaGem",
          selected: false,
          key: "language",
        },
        {
          id: 3,
          language_id: 83,
          title: " Swift",
          mode: "swift",
          fa_icon: "FaSwift",
          selected: false,
          key: "language",
        },
        {
          id: 4,
          language_id: 62,
          title: " Java",
          mode: "text/x-java",
          fa_icon: "FaJava",
          selected: false,
          key: "language",
        },
        {
          id: 5,
          language_id: 60,
          title: " Go",
          mode: "text/x-go",
          fa_icon: "FaGoogle",
          selected: false,
          key: "language",
        },
        {
          id: 6,
          language_id: 78,
          title: " Kotlin",
          mode: "text/x-kotlin",
          fa_icon: "FaAndroid",
          selected: false,
          key: "language",
        },
        {
          id: 7,
          language_id: 68,
          title: " PHP",
          mode: "application/x-httpd-php",
          fa_icon: "FaPhp",
          selected: false,
          key: "language",
        },
        {
          id: 8,
          language_id: 80,
          title: " R",
          mode: "text/x-rsrc",
          fa_icon: "FaRProject",
          selected: false,
          key: "language",
        },
        {
          id: 9,
          language_id: 81,
          title: " Scala",
          mode: "text/x-scala",
          fa_icon: "FaBars",
          selected: false,
          key: "language",
        },
        {
          id: 10,
          language_id: 54,
          title: " C++",
          mode: "text/x-c++src",
          fa_icon: "SiCplusplus",
          selected: false,
          key: "language",
        },
        {
          id: 11,
          language_id: 43,
          title: " plntxt",
          mode: "text/plain",
          fa_icon: "BsCursorText",
          selected: false,
          key: "language",
        },
      ],
      currlang: " Python",
      cursorPosition: {
        line: 0,
        ch: 0,
      },
      witeboard: null,
      sessionid: null,
      darkMode: this.props.darkMode,
      evalExtend: false,
      timerExtend: true,
      whiteboardExtend: false,
      agentPanelWidthPx: null,
      openAiToggle: false,
      borderToggle: true,
      completionToggle: sessionStorage.getItem("completionToggle") === "true" || false,
      flanT5Toggle: false,
      anthropicToggle: false,
      GrokAIToggle: false,
      PaLMToggle: false,
      GeminiToggle: false,
      token: null,
      evalOutput: sessionStorage.getItem("evalOutput") || null,
      compileOutput: sessionStorage.getItem("compileOutput") || null,
      memory: null,
      time: null,
      history: {},
      output: null,
      output2: "",
      output3: "",
      modelOutput: [],
      usage: null,
      cardCreated: null,
      hotkeys: null,
      cards: [],
      cardsOpenAI: [],
      cardsHF: [],
      cardsPaLM: [],
      cardsGemini: [],
      cardsAnthropic: [],
      lastQueryTime: null,
      login: false,
      transcript: [],
      aiAssistant: [],
      isDevelopment: false,
      isTyping: false,
      typingTimeout: null,
      firebaseUpdateTimeout: null,
      isPrivate: false,
      // Anti-abuse state
      lastRunTime: 0,
      runCount: 0,
      abuseWarning: null,
      // Share modal state
      showShareModal: false,
      shareLink: "",
      copySuccess: false,
      evalOutputDB: null,
      // Presence state
      members: [],
      yourID: "",
      // Interview context (for company interviews - passed to voice agent)
      interviewContext: null,
      // Tab selection
      activeTab: "code",
      // Per-member active tab (for header tab indicator)
      memberActiveTabs: {},
      // Diagram live collaboration (pointer overlay) - visible toggle on both tabs
      diagramCollaborationOn: false,
      // Diagram content for voice agent (systems design interviews)
      diagramContent: "",
      // Credits check for interviews (null = not checked, true = can start, false = blocked)
      creditsCanStart: null
    };
    this.cardsEndRef = React.createRef();
    this.aiCardRef = React.createRef();
    // Socket for cursor/selection tracking
    this.socket = null;
    this.remoteCursors = new Map(); // Map<socketId, { element }> - overlay elements, no layout impact
    this.remoteCursorPositions = new Map(); // Map<socketId, { position, member }> - for re-apply after setValue
    this.remoteSelections = new Map(); // Map<socketId, marker>
    this.cursorUpdateTimeout = null;
    this.selectionUpdateTimeout = null;
    this.cursorLabelTimeouts = new Map(); // Map<socketId, timeout> for label hide timers
    this.userCursors = new Map(); // Map<userId (name+color), socketId> - track which socketId represents each user
    this.cursorRequestInterval = null;
    this.diagramUnsubscribe = null;
    this._lastDiagramSessionKey = null;
    this.scrollToBottom = this.scrollToBottom.bind(this);
    this.toggleLanguage = this.toggleLanguage.bind(this);
    this.toggleExtend = this.toggleExtend.bind(this);
    this.toggleTimer = this.toggleTimer.bind(this);
    this.toggleWhiteboard = this.toggleWhiteboard.bind(this);
    this.toggleBorder = this.toggleBorder.bind(this);
    this.toggleCompletion = this.toggleCompletion.bind(this);
    this.whiteboardRender = this.whiteboardRender.bind(this);
    this.loginRender = this.loginRender.bind(this);
    this.toolTipRender = this.toolTipRender.bind(this);
    this.runCode = this.runCode.bind(this);
    this.useOpenAI = this.useOpenAI.bind(this);
    this.useHuggingFace = this.useHuggingFace.bind(this);
    this.useAnthropic = this.useAnthropic.bind(this);
    this.usePaLM = this.usePaLM.bind(this);
    this.useGemini = this.useGemini.bind(this);
    this.toggleAnthropic = this.toggleAnthropic.bind(this);
    this.togglePaLM = this.togglePaLM.bind(this);
    this.toggleGrokAI = this.toggleGrokAI.bind(this);
    this.toggleGemini = this.toggleGemini.bind(this);
    this.toggleFlanT5 = this.toggleFlanT5.bind(this);
    this.mapCards = this.mapCards.bind(this);
    this.closeCard = this.closeCard.bind(this);
    this.copyCard = this.copyCard.bind(this);
    this.poweredBy = this.poweredBy.bind(this);
    this.handleAiCardWheel = this.handleAiCardWheel.bind(this);
    this.logout = this.logout.bind(this);
    this.login = this.login.bind(this);
    this.acceptSuggestion = this.acceptSuggestion.bind(this);
    this.denySuggestion = this.denySuggestion.bind(this);
    this.updateAssistant = this.updateAssistant.bind(this);
    this.auth = getAuth();
    this.db = getDatabase();
    // Anti-abuse tracking
    this.runCodeThrottle = this.runCodeThrottle.bind(this);
    this.checkAbuseLimits = this.checkAbuseLimits.bind(this);
    this.showAbuseWarning = this.showAbuseWarning.bind(this);
    // Share functionality
    this.openShareModal = this.openShareModal.bind(this);
    this.closeShareModal = this.closeShareModal.bind(this);
    this.copyToClipboard = this.copyToClipboard.bind(this);
    this.generateShareLink = this.generateShareLink.bind(this);
    this.togglePrivacy = this.togglePrivacy.bind(this);
    // Presence functionality
    this.updatePresence = this.updatePresence.bind(this);
  }

  componentDidMount() {
    this.initializeSession(this.props.sessionid);
  }

  componentDidUpdate(prevProps, prevState) {
    // If the sessionid prop changed, reinitialize the session
    if (prevProps.sessionid !== this.props.sessionid) {
      this.initializeSession(this.props.sessionid);
    }
    // Set up diagram subscription when sessionid is available (for voice agent context)
    // Use a ref to avoid re-running on every update (prevents infinite loop when sessionid
    // comes from props before state is populated)
    const sessionid = this.state.sessionid || this.props.sessionid;
    const diagramKey = sessionid ? `${sessionid}-${this.state.isPrivate}` : null;
    if (diagramKey && diagramKey !== this._lastDiagramSessionKey) {
      this._lastDiagramSessionKey = diagramKey;
      this.setupDiagramSubscription(sessionid);
    }
    // When agent panel opens, observe its width so video chat stays aligned
    if (this.state.whiteboardExtend && !prevState.whiteboardExtend) {
      this.setupAgentPanelResizeObserver();
    }
    if (!this.state.whiteboardExtend && prevState.whiteboardExtend) {
      this.agentPanelResizeObserver?.disconnect();
      this.agentPanelResizeObserver = null;
      this.setState({ agentPanelWidthPx: null });
    }
  }

  setupAgentPanelResizeObserver() {
    if (this.agentPanelResizeObserver) {
      this.agentPanelResizeObserver.disconnect();
    }
    const observePanel = () => {
      const wrapper = this.agentPanelRef;
      if (!wrapper || !wrapper.firstElementChild) return;
      const resizableEl = wrapper.firstElementChild;
      this.agentPanelResizeObserver = new ResizeObserver((entries) => {
        for (const entry of entries) {
          const width = entry.contentRect.width;
          if (width > 0) {
            this.setState({ agentPanelWidthPx: width });
          }
        }
      });
      this.agentPanelResizeObserver.observe(resizableEl);
    };
    requestAnimationFrame(() => {
      requestAnimationFrame(observePanel);
    });
  }

  componentWillUnmount() {
    // Clean up any active EventSource connections
    if (this.currentEventSource) {
      this.currentEventSource.close();
      this.currentEventSource = null;
    }

    // Clear any pending timers
    if (this.inputTimer) {
      clearTimeout(this.inputTimer);
    }
    if (this.firebaseUpdateTimeout) {
      clearTimeout(this.firebaseUpdateTimeout);
    }
    if (this.cursorUpdateTimeout) {
      clearTimeout(this.cursorUpdateTimeout);
    }
    if (this.selectionUpdateTimeout) {
      clearTimeout(this.selectionUpdateTimeout);
    }

    this.agentPanelResizeObserver?.disconnect();
    this.agentPanelResizeObserver = null;

    if (this.cursorRequestInterval) {
      clearInterval(this.cursorRequestInterval);
      this.cursorRequestInterval = null;
    }

    // Disconnect socket - we own it directly now
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }

    // Clean up remote cursor/selection indicators
    this.cleanupRemoteCursors();
    this.cleanupRemoteSelections();

    // Clean up diagram subscription
    if (this.diagramUnsubscribe) {
      this.diagramUnsubscribe();
      this.diagramUnsubscribe = null;
    }
    this._lastDiagramSessionKey = null;
  }

  getDiagramPath(sessionId, isPrivate, userId) {
    if (isPrivate && userId) {
      return `private-sandboxes/${userId}/${sessionId}/diagram`;
    }
    return `code-sessions/${sessionId}/diagram`;
  }

  setupDiagramSubscription(sessionid) {
    if (!sessionid || !this.db) return;
    if (this.diagramUnsubscribe) {
      this.diagramUnsubscribe();
      this.diagramUnsubscribe = null;
    }
    const auth = getAuth();
    const user = auth.currentUser;
    const path = this.getDiagramPath(sessionid, this.state.isPrivate, user?.uid ?? null);
    const diagramRef = ref(this.db, path);
    this.diagramUnsubscribe = onValue(diagramRef, (snapshot) => {
      if (!snapshot.exists()) {
        this.setState({ diagramContent: "" });
        return;
      }
      const data = snapshot.val();
      const text = diagramDataToText(data);
      if (text && process.env.NODE_ENV === "development") {
        console.log("📋 Diagram content for agent:", text.length, "chars");
      }
      this.setState({ diagramContent: text });
    });
  }

  buildInterviewContext(data) {
    if (!data || !data.isInterview) return null;
    const ctx = {
      title: data.interviewTitle || '',
      description: data.interviewDescription || '',
      instructions: data.interviewInstructions || '',
      content: data.content || '',
      difficulty: data.interviewDifficulty || 'Medium',
      timeLimit: data.interviewTimeLimit || 60,
      allowedLanguages: data.interviewAllowedLanguages || [],
      interviewType: data.interviewType || 'coding',
      candidateName: data.candidateName || '',
      candidateLinkedIn: data.candidateLinkedIn || '',
      candidateDocuments: data.candidateDocuments || [],
      candidateResearchData: data.candidateResearchData || '',
      agentSystemPrompt: data.agentSystemPrompt || null
    };
    if (ctx.candidateName || ctx.candidateResearchData) {
      console.log('📋 Loaded interview context for voice agent:', {
        candidateName: ctx.candidateName,
        hasResearch: !!ctx.candidateResearchData,
        docCount: (ctx.candidateDocuments || []).length
      });
    } else if (data.isInterview) {
      console.warn('⚠️ Interview session has no candidate profile data. Republish the interview from the Interview Editor to include candidate name, resume, and background research.');
    }
    return ctx;
  }

  async checkCreditsForInterview(interviewId, timeLimitMinutes = 60) {
    try {
      const res = await fetch(`${getBaseURL()}/api/credits/check/${encodeURIComponent(interviewId)}`);
      const data = await res.json();
      const canStart = data.canStart !== false;
      this.setState({ creditsCanStart: canStart });
      if (canStart) {
        try {
          await fetch(`${getBaseURL()}/api/interview-sessions/start`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              interviewId,
              sessionId: interviewId,
              timeLimitMinutes: timeLimitMinutes || 60,
            }),
          });
        } catch (e) {
          console.warn('Failed to start interview session:', e);
        }
      }
    } catch {
      this.setState({ creditsCanStart: true }); // Fail open
    }
  }

  initializeSession(sessionid) {
    const self = this;
    const dbRef = ref(this.db);
    const auth = getAuth();
    const user = auth.currentUser;

    // Determine if the session is private
    if (user) {
      const userId = user.uid;
      get(ref(this.db, `private-sandboxes/${userId}/${sessionid}`)).then((snapshot) => {
        if (snapshot.exists()) {
          this.setState({ isPrivate: true });
          // Load from private-sandboxes
          const data = snapshot.val();

          // Check if we have fresh output in sessionStorage first
          const freshOutput = sessionStorage.getItem("evalOutput");
          const freshCompileOutput = sessionStorage.getItem("compileOutput");
          const defaultToDiagram = data.interviewType === 'system-design' || data.defaultTab === 'diagram';

          this.setState({
            code: data.content || '',
            evalOutput: freshOutput || data.evalOutput || undefined,
            compileOutput: freshCompileOutput || data.compileOutput || undefined,
            evalOutputDB: freshOutput ? null : data.evalOutput, // Only set DB output if no fresh output
            witeboard: "https://witeboard.com/" + sessionid,
            sessionid: sessionid,
            interviewContext: data.isInterview ? this.buildInterviewContext(data) : null,
            activeTab: defaultToDiagram ? 'diagram' : 'code'
          }, () => {
            if (data.isInterview) this.checkCreditsForInterview(sessionid, data.interviewTimeLimit);
          });

          // Store evalOutputDB in sessionStorage for consistency
          if (!freshOutput && data.evalOutput) {
            sessionStorage.setItem("evalOutputDB", data.evalOutput);
          }
        } else {
          // If not in private-sandboxes, try code-sessions
          get(ref(this.db, `code-sessions/${sessionid}`)).then((snapshot) => {
            if (snapshot.exists()) {
              this.setState({ isPrivate: false });
              const data = snapshot.val();

              // Check if we have fresh output in sessionStorage first
              const freshOutput = sessionStorage.getItem("evalOutput");
              const freshCompileOutput = sessionStorage.getItem("compileOutput");
              const defaultToDiagram = data.interviewType === 'system-design' || data.defaultTab === 'diagram';

              this.setState({
                code: data.content || '',
                evalOutput: freshOutput || data.evalOutput || undefined,
                compileOutput: freshCompileOutput || data.compileOutput || undefined,
                evalOutputDB: freshOutput ? null : data.evalOutput, // Only set DB output if no fresh output
                witeboard: "https://witeboard.com/" + sessionid,
                sessionid: sessionid,
                interviewContext: data.isInterview ? this.buildInterviewContext(data) : null,
                activeTab: defaultToDiagram ? 'diagram' : 'code'
              }, () => {
                if (data.isInterview) this.checkCreditsForInterview(sessionid);
              });

              // Store evalOutputDB in sessionStorage for consistency
              if (!freshOutput && data.evalOutput) {
                sessionStorage.setItem("evalOutputDB", data.evalOutput);
              }
            } else {
              console.error("Session not found");
            }
          });
        }
      });
    } else {
      // For non-authenticated users, load from code-sessions
      get(ref(this.db, `code-sessions/${sessionid}`)).then((snapshot) => {
        if (snapshot.exists()) {
          this.setState({ isPrivate: false });
          const data = snapshot.val();

          // Check if we have fresh output in sessionStorage first
          const freshOutput = sessionStorage.getItem("evalOutput");
          const freshCompileOutput = sessionStorage.getItem("compileOutput");
          const defaultToDiagram = data.interviewType === 'system-design' || data.defaultTab === 'diagram';

          this.setState({
            code: data.content || '',
            evalOutput: freshOutput || data.evalOutput || undefined,
            compileOutput: freshCompileOutput || data.compileOutput || undefined,
            evalOutputDB: freshOutput ? null : data.evalOutput, // Only set DB output if no fresh output
            witeboard: "https://witeboard.com/" + sessionid,
            sessionid: sessionid,
            interviewContext: data.isInterview ? this.buildInterviewContext(data) : null,
            activeTab: defaultToDiagram ? 'diagram' : 'code'
          }, () => {
            if (data.isInterview) this.checkCreditsForInterview(sessionid, data.interviewTimeLimit);
          });

          // Store evalOutputDB in sessionStorage for consistency
          if (!freshOutput && data.evalOutput) {
            sessionStorage.setItem("evalOutputDB", data.evalOutput);
          }
        } else {
          console.error("Session not found");
        }
      });
    }

    // Initialize Socket.IO directly for presence + cursor tracking
    // (previously handled by VideoChat component)
    this.initializeSocket(sessionid);

    // Add cursor activity handler and mouse wheel support after CodeMirror is initialized
    const setupCursorTracking = () => {
      if (self.codemirror && self.codemirror.getCodeMirror()) {
        const cm = self.codemirror.getCodeMirror();

        cm.on('cursorActivity', () => {
          const cursorPosition = cm.getCursor();
          const hasSelection = cm.somethingSelected() ? {
            anchor: cm.getCursor('anchor'),
            head: cm.getCursor('head')
          } : null;

          // Only update if position actually changed
          if (cursorPosition.line !== self.state.cursorPosition.line ||
            cursorPosition.ch !== self.state.cursorPosition.ch) {

            // Clear any pending cursor updates
            if (self.cursorUpdateTimeout) {
              clearTimeout(self.cursorUpdateTimeout);
            }

            // Update local state immediately for responsive cursor movement
            self.setState({ cursorPosition });

            // Emit cursor position via socket (debounced)
            if (self.socket && self.socket.connected && self.state.yourID) {
              self.cursorUpdateTimeout = setTimeout(() => {
                self.socket.emit('cursor-update', {
                  sessionid: sessionid,
                  position: cursorPosition,
                  selection: hasSelection,
                  activeTab: 'code'
                });
              }, 100); // Throttle to 10 updates per second
            }

            // Debounce Firebase updates to prevent rapid writes
            const cursorUpdateTimeout = setTimeout(() => {
              // Only update Firebase if we're not currently typing
              if (!self.isTyping) {
                sessionStorage.setItem('cursorPosition', JSON.stringify(cursorPosition));
                update(child(dbRef, `code-sessions/${self.state.sessionid}`), {
                  cursorPosition: cursorPosition
                });
              }
            }, 500);
          }

          // Handle selection changes
          if (hasSelection && self.socket && self.socket.connected && self.state.yourID) {
            if (self.selectionUpdateTimeout) {
              clearTimeout(self.selectionUpdateTimeout);
            }
            self.selectionUpdateTimeout = setTimeout(() => {
              self.socket.emit('selection-update', {
                sessionid: sessionid,
                selection: hasSelection
              });
            }, 150);
          } else if (!hasSelection && self.socket && self.socket.connected && self.state.yourID) {
            // Clear selection
            if (self.selectionUpdateTimeout) {
              clearTimeout(self.selectionUpdateTimeout);
            }
            self.socket.emit('selection-clear', {
              sessionid: sessionid
            });
          }
        });

        // On focus: emit our cursor and request others' so cursors show immediately (like diagram tab)
        cm.on('focus', () => {
          if (self.socket && self.socket.connected && self.state.yourID && sessionid) {
            const pos = cm.getCursor();
            const sel = cm.somethingSelected() ? { anchor: cm.getCursor('anchor'), head: cm.getCursor('head') } : null;
            self.socket.emit('cursor-update', {
              sessionid: sessionid,
              position: pos,
              selection: sel,
              activeTab: 'code'
            });
            self.socket.emit('request-cursor-positions', { sessionid: sessionid });
          }
        });

        // Add mouse wheel and touch event handlers for better scroll support
        const cmWrapper = cm.getWrapperElement();

        const handleWheel = (e) => {
          // Only handle wheel events if the target is within CodeMirror
          // This allows other scrollable elements (like Eval output) to handle their own scroll
          const target = e.target;
          const isCodeMirrorElement = target.closest('.CodeMirror') === cmWrapper;

          if (!isCodeMirrorElement) {
            // Let other elements handle their own scroll
            return;
          }

          // Prevent default to avoid browser scroll
          e.preventDefault();

          // Calculate scroll amount
          const delta = e.deltaY || e.detail || e.wheelDelta;
          const lineHeight = cm.defaultTextHeight();
          const scrollAmount = Math.sign(delta) * lineHeight * 3; // Scroll 3 lines at a time

          // Get current scroll position
          const scrollInfo = cm.getScrollInfo();

          // Scroll the editor
          cm.scrollTo(scrollInfo.left, scrollInfo.top + scrollAmount);
        };

        // Smooth touch handling for mobile devices (iOS-like scrolling)
        let touchStartY = 0;
        let touchStartTime = 0;
        let lastTouchY = 0;
        let lastTouchTime = 0;
        let isScrolling = false;
        let velocityY = 0;
        let momentumAnimation = null;
        let velocityHistory = []; // Track velocity for smoothing

        const handleTouchStart = (e) => {
          if (e.touches.length === 1) {
            // Cancel any ongoing momentum scrolling
            if (momentumAnimation) {
              cancelAnimationFrame(momentumAnimation);
              momentumAnimation = null;
            }

            touchStartY = e.touches[0].clientY;
            lastTouchY = touchStartY;
            touchStartTime = Date.now();
            lastTouchTime = touchStartTime;
            isScrolling = false;
            velocityY = 0;
            velocityHistory = []; // Reset velocity history on new touch
          }
        };

        const handleTouchMove = (e) => {
          if (e.touches.length === 1) {
            const currentTime = Date.now();
            const touchY = e.touches[0].clientY;
            const deltaY = lastTouchY - touchY;
            const timeDelta = currentTime - lastTouchTime;

            // Calculate velocity for momentum scrolling with smoothing
            if (timeDelta > 0) {
              const currentVel = deltaY / timeDelta;
              velocityHistory.push(currentVel);

              // Keep only last 3 velocity readings for smoothing
              if (velocityHistory.length > 3) {
                velocityHistory.shift();
              }

              // Average the velocity for smoother momentum
              velocityY = velocityHistory.reduce((sum, vel) => sum + vel, 0) / velocityHistory.length;
            }

            // Only prevent default and scroll if there's significant movement
            if (Math.abs(deltaY) > 0.3) { // Lower threshold for more responsive scrolling
              e.preventDefault(); // Prevent default iOS scroll
              isScrolling = true;

              // Smooth, responsive scrolling with natural bounds
              const scrollInfo = cm.getScrollInfo();
              const newScrollTop = scrollInfo.top + deltaY;

              // Use CodeMirror's natural bounds with minimal buffer to prevent overshoot
              const naturalMaxScroll = Math.max(0, scrollInfo.height - scrollInfo.clientHeight);
              const maxScroll = naturalMaxScroll + 10; // Minimal buffer to prevent overshoot

              // Add mobile-specific bounds checking
              const isMobile = window.innerWidth <= 768;
              const minScroll = isMobile ? 0 : -10; // Strict zero bound on mobile
              const clampedScrollTop = Math.max(minScroll, Math.min(newScrollTop, maxScroll));

              cm.scrollTo(scrollInfo.left, clampedScrollTop);
            }

            // Update for next iteration
            lastTouchY = touchY;
            lastTouchTime = currentTime;
          }
        };

        const handleTouchEnd = () => {
          if (isScrolling && Math.abs(velocityY) > 0.05) { // Lower threshold for momentum
            // Start momentum scrolling based on velocity
            let currentVelocity = velocityY * 20; // Increased multiplier for more responsive momentum
            const friction = 0.92; // Slightly more friction for smoother deceleration
            const minVelocity = 0.05; // Lower threshold for longer momentum
            let frameCount = 0;

            const momentumScroll = () => {
              frameCount++;
              if (Math.abs(currentVelocity) < minVelocity) {
                momentumAnimation = null;
                // Light final refresh only if needed (reduce calculation lag)
                setTimeout(() => cm.refresh(), 100);
                return;
              }

              const scrollInfo = cm.getScrollInfo();
              const newScrollTop = scrollInfo.top + currentVelocity;

              // Use CodeMirror's natural bounds with minimal buffer to prevent overshoot
              const naturalMaxScroll = Math.max(0, scrollInfo.height - scrollInfo.clientHeight);
              const maxScroll = naturalMaxScroll + 10; // Minimal buffer to prevent overshoot

              // Add mobile-specific bounds checking
              const isMobile = window.innerWidth <= 768;
              const minScroll = isMobile ? 0 : -10; // Strict zero bound on mobile
              const clampedScrollTop = Math.max(minScroll, Math.min(newScrollTop, maxScroll));

              // Stop momentum if we hit boundaries
              if (newScrollTop < 0 || newScrollTop > maxScroll) {
                momentumAnimation = null;
                return;
              }

              cm.scrollTo(scrollInfo.left, clampedScrollTop);

              // Remove frequent refresh to prevent calculation lag

              currentVelocity *= friction;
              momentumAnimation = requestAnimationFrame(momentumScroll);
            };

            momentumAnimation = requestAnimationFrame(momentumScroll);
          }

          isScrolling = false;
        };

        // Add event listeners for desktop mouse wheel events
        cmWrapper.addEventListener('wheel', handleWheel, { passive: false });
        cmWrapper.addEventListener('DOMMouseScroll', handleWheel, { passive: false }); // Firefox
        cmWrapper.addEventListener('mousewheel', handleWheel, { passive: false }); // Older browsers

        // Add event listeners for mobile touch events
        cmWrapper.addEventListener('touchstart', handleTouchStart, { passive: false });
        cmWrapper.addEventListener('touchmove', handleTouchMove, { passive: false });
        cmWrapper.addEventListener('touchend', handleTouchEnd, { passive: true });
      }
    };

    const isDevelopment = process.env.REACT_APP_IS_DEVELOPMENT === 'true';
    this.setState({ isDevelopment }, () => {
      // Setup cursor tracking after initial state is set
      setupCursorTracking();
    });

    // Utility function to simplify getting session storage items as booleans
    const getBooleanFromSession = (key) => sessionStorage.getItem(key) === 'true';

    if (sessionStorage.getItem("currlang")) {
      const key = sessionStorage.getItem("key");
      const mode = sessionStorage.getItem("mode");
      const language_id = sessionStorage.getItem("language_id");
      const currlang = sessionStorage.getItem("currlang");
      self.setState({ key, mode, language_id, currlang });
    }

    const historyFromLocal = localStorage.getItem("history");
    if (historyFromLocal) {
      this.setState({ history: JSON.parse(historyFromLocal) });
    }

    const borderToggleFromSession = sessionStorage.getItem("borderToggle");
    if (borderToggleFromSession) {
      this.setState({ borderToggle: JSON.parse(borderToggleFromSession) });
    }

    const whiteboardExtendFromSession = sessionStorage.getItem("whiteboardExtend");
    if (whiteboardExtendFromSession) {
      this.setState({ whiteboardExtend: getBooleanFromSession("whiteboardExtend") });
    }

    // For toggles that are booleans in session storage
    const toggles = ["flanT5Toggle", "anthropicToggle", "GrokAIToggle", "GeminiToggle", "completionToggle"];
    toggles.forEach(toggle => {
      const value = sessionStorage.getItem(toggle);
      if (value) {
        self.setState({ [toggle]: getBooleanFromSession(toggle) });
      }
    });

    // Set up auth state listener
    onAuthStateChanged(this.auth, (user) => {
      if (user) {
        const uid = user.uid;

        if (sessionStorage.getItem("openAiToggle") === "false") {
          this.setState({
            openAiToggle: false
          });
        } else if (sessionStorage.getItem("openAiToggle") === "true") {
          this.setState({
            openAiToggle: true
          });
        }
        this.setState({
          user: user,
          login: true,
        });
      } else {
        this.setState({
          login: false,
        });
      }
    });

    // Server-side only approach for initial session data
    const fetchSessionData = async () => {
      try {
        const baseURL = getBaseURL();

        const apiUrl = `${baseURL}/api/sessions/${sessionid}`;

        const response = await fetch(apiUrl, {
          method: 'GET',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          }
        });

        if (!response.ok) {
          const errorText = await response.text();
          console.error('API error response:', errorText);
          throw new Error(`API request failed with status ${response.status}: ${errorText}`);
        }

        const sessionData = await response.json();

        // Always set the server data first, then try to get cursor position from Firebase
        this.setState({
          code: sessionData.content || '',
          evalOutput: sessionData.evalOutput || undefined,
          compileOutput: sessionData.compileOutput || undefined,
          witeboard: "https://witeboard.com/" + sessionid,
          sessionid: sessionid,
        });

        // Try to get cursor position from Firebase (optional enhancement)
        const sessionRef = ref(this.db, `code-sessions/${sessionid}`);
        get(sessionRef).then((snapshot) => {
          if (snapshot.exists()) {
            const data = snapshot.val();
            const savedCursorPosition = data.cursorPosition;

            if (savedCursorPosition && self.codemirror && self.codemirror.getCodeMirror()) {
              this.setState({ cursorPosition: savedCursorPosition }, () => {
                const cm = self.codemirror.getCodeMirror();
                // Content was already set from server, just position cursor
                cm.setCursor(savedCursorPosition);
                setTimeout(() => {
                  cm.focus();
                  cm.refresh();
                  // Force cursor to be visible by moving it slightly and back
                  const { line, ch } = savedCursorPosition;
                  cm.setCursor({ line, ch: ch + 1 });
                  cm.setCursor(savedCursorPosition);
                }, 100);
              });
            }
          }

          // Ensure CodeMirror gets updated even if Firebase fails
          if (self.codemirror && self.codemirror.getCodeMirror()) {
            const cm = self.codemirror.getCodeMirror();
            cm.setValue(sessionData.content || '');
            setTimeout(() => {
              cm.focus();
              cm.refresh();
              cm.setSize(null, null);
              cm.refresh();
              if (!this.state.cursorPosition) {
                const lastLine = cm.lastLine();
                const lastChar = cm.getLine(lastLine).length;
                cm.setCursor({ line: lastLine, ch: lastChar });
              }
              self.reapplyRemoteCursors();
            }, 100);
          }
        }).catch(() => {
          if (self.codemirror && self.codemirror.getCodeMirror()) {
            const cm = self.codemirror.getCodeMirror();
            cm.setValue(sessionData.content || '');
            setTimeout(() => {
              cm.focus();
              cm.refresh();
              cm.setSize(null, null);
              cm.refresh();
              const lastLine = cm.lastLine();
              const lastChar = cm.getLine(lastLine).length;
              cm.setCursor({ line: lastLine, ch: lastChar });
              self.reapplyRemoteCursors();
            }, 100);
          }
        });

      } catch (error) {
        console.error("Server API error details:", {
          message: error.message,
          stack: error.stack,
          name: error.name,
          cause: error.cause
        });

        // Check if it's a network error vs server error
        if (error.name === 'TypeError' && error.message.includes('fetch')) {
          console.error("Network error - server might be down or CORS issue");
        } else if (error.name === 'SyntaxError') {
          console.error("JSON parsing error - server returned invalid JSON");
        } else {
          console.error("Unknown error type:", error);
        }

        // Server-side only: no fallback to Firebase or sessionStorage
        // Set empty content and let user know server is required
        this.setState({
          code: '# Server unavailable. Please check your connection and try again.',
          evalOutput: undefined,
          compileOutput: undefined,
          witeboard: "https://witeboard.com/" + sessionid,
          sessionid: sessionid,
        }, () => {
          if (self.codemirror && self.codemirror.getCodeMirror()) {
            self.codemirror.getCodeMirror().setValue('# Server unavailable. Please check your connection and try again.');
          }
        });
      }
    };

    // Call the API function
    fetchSessionData();

    // Set up real-time listener for code changes BUT not for initial content loading
    // Only listen for changes AFTER initial server load is complete
    let initialContentLoaded = false;

    const sessionRef = ref(this.db, `code-sessions/${sessionid}`);
    onValue(sessionRef, (snapshot) => {
      if (snapshot.exists() && initialContentLoaded) {
        const data = snapshot.val();
        const content = data.content;
        const evalOutput = data.evalOutput;
        const compileOutput = data.compileOutput;
        const cursorPosition = data.cursorPosition;

        // Firebase real-time update (after initial load)

        // Only update if the content is different from current state
        if (content !== this.state.code) {
          this.setState(prevState => {
            const newState = {
              code: content,
              evalOutput: evalOutput || prevState.evalOutput,
              compileOutput: compileOutput || prevState.compileOutput,
            };

            // Only update cursor position if we're not currently typing
            // and the cursor position is different
            if (!this.isTyping && cursorPosition &&
              (cursorPosition.line !== prevState.cursorPosition.line ||
                cursorPosition.ch !== prevState.cursorPosition.ch)) {
              newState.cursorPosition = cursorPosition;
            }
            return newState;
          }, () => {
            if (self.codemirror && self.codemirror.getCodeMirror()) {
              const cm = self.codemirror.getCodeMirror();
              cm.setValue(content);

              // Only update cursor if we're not typing
              if (!this.isTyping && cursorPosition) {
                cm.setCursor(cursorPosition);
                setTimeout(() => {
                  cm.focus();
                  cm.refresh();
                }, 100);
              }
              // Re-apply remote cursors (setValue clears document and removes bookmark widgets)
              setTimeout(() => self.reapplyRemoteCursors(), 50);
            }
          });
        }
      } else if (snapshot.exists() && !initialContentLoaded) {
        // Firebase data exists but ignoring for initial load (server-side only)
      }
    });

    // Set flag to allow Firebase updates after a short delay (server should have loaded by then)
    setTimeout(() => {
      initialContentLoaded = true;
      // Now allowing Firebase real-time updates
    }, 3000); // 3 second delay to ensure server load completes first

    this.updateUserSessionLastAccessed();
  }

  handleCodeChange(newVal) {
    if (!this.codemirror || !this.codemirror.getCodeMirror()) {
      return;
    }

    const dbRef = ref(this.db);
    const auth = getAuth();
    const user = auth.currentUser;

    if (this.state.isPrivate && user) {
      // Write to private-sandboxes for authenticated users
      update(child(dbRef, `private-sandboxes/${user.uid}/${this.state.sessionid}`), {
        content: newVal
      });
    } else {
      // Write to code-sessions for non-authenticated users or public sandboxes
      update(child(dbRef, `code-sessions/${this.state.sessionid}`), {
        content: newVal
      });
    }
  }

  updateAssistant(newVal) {
    if (!this.codemirror || !this.codemirror.getCodeMirror()) {
      return;
    }

    const dbRef = ref(this.db);
    const auth = getAuth();
    const user = auth.currentUser;

    if (this.state.isPrivate && user) {
      // Write to private-sandboxes for authenticated users
      return update(child(dbRef, `private-sandboxes/${user.uid}/${this.state.sessionid}`), {
        content: newVal
      });
    } else {
      // Write to code-sessions for non-authenticated users or public sandboxes
      return update(child(dbRef, `code-sessions/${this.state.sessionid}`), {
        content: newVal
      });
    }
  }

  handleKeyEvent(action, keyName) {
    this.setState({
      hotkeys: `${action} ${keyName}`,
    });
  }

  onKeyUp(keyName) {
    this.handleKeyEvent('onKeyUp', keyName);
  }

  onKeyDown(keyName) {
    this.handleKeyEvent('onKeyDown', keyName);
    this.runCode();
  }

  handleEscapeKey() {
    if (this.state.codeSuggestion && this.state.suggestionRange) {
      // Clear all marks first (visual highlighting)
      this.codemirror.getCodeMirror().doc.getAllMarks().forEach(marker => marker.clear());

      // Clear the suggestion text using the stored range
      this.codemirror.getCodeMirror().doc.replaceRange("",
        this.state.suggestionRange.from,
        this.state.suggestionRange.to
      );

      // Clear state to hide tooltip
      this.setState({
        charCoords: undefined,
        codeSuggestion: "",
        suggestionRange: undefined
      });
    }
  }

  handleShiftTab() {
    if (this.state.codeSuggestion && this.state.suggestionRange) {
      // Clear all marks first (visual highlighting)
      this.codemirror.getCodeMirror().doc.getAllMarks().forEach(marker => marker.clear());
      // Move cursor to end of accepted suggestion
      this.codemirror.getCodeMirror().doc.setCursor(
        this.state.suggestionRange.to.line,
        this.state.suggestionRange.to.ch
      );
      // Clear state to hide tooltip
      this.setState({
        charCoords: undefined,
        codeSuggestion: "",
        suggestionRange: undefined
      });
    }
  }

  aiCompletion = () => {
    // Cancel any existing completion request
    if (this.currentEventSource) {
      this.currentEventSource.close();
      this.currentEventSource = null;
    }

    // Clear any existing suggestion
    if (this.state.codeSuggestion) {
      this.setState({
        codeSuggestion: "",
        suggestionRange: undefined
      });
    }

    // Determine environment and return the corresponding URL
    const baseURL = getBaseURL();
    const { currlang, sessionid, code, suffix } = this.state;

    // Get current cursor position and line context for better completion
    const cm = this.codemirror.getCodeMirror();
    const currentCursor = cm.getCursor(); // Get current cursor position directly from CodeMirror
    const { line, ch } = currentCursor;
    const currentLine = cm.getLine(line);
    const textBeforeCursor = currentLine.substring(0, ch);
    const textAfterCursor = currentLine.substring(ch);
    const currentCode = cm.getValue(); // Get current code directly from CodeMirror

    console.log("Current cursor position from CodeMirror:", currentCursor);
    console.log("Current code from CodeMirror:", currentCode);
    console.log("Text before cursor:", textBeforeCursor);
    console.log("Text after cursor:", textAfterCursor);

    // Create a more specific completion request
    const completionParams = new URLSearchParams({
      language: currlang,
      sessionid: sessionid,
      code: currentCode,
      suffix: suffix,
      cursorLine: line.toString(),
      cursorChar: ch.toString(),
      textBeforeCursor: textBeforeCursor,
      textAfterCursor: textAfterCursor
    });

    this.currentEventSource = new EventSource(`${baseURL}/completion?${completionParams.toString()}`);
    let evntSrtm = this.currentEventSource;

    console.log("EventSource created for completion request");
    console.log("URL:", `${baseURL}/completion?${completionParams.toString()}`);

    evntSrtm.addEventListener("open", () => {
      console.log("EventSource connection opened");
    });

    evntSrtm.addEventListener("error", (error) => {
      console.error("EventSource error:", error);
    });

    evntSrtm.addEventListener("message", (event) => {
      console.log("Received completion event:", event.data);
      if (event.data === '[DONE]') {
        console.log("Completion stream finished");
        handleDoneEvent();
      } else if (event.data[0] === "d") {
        console.log("Handling D event");
        handleDStartEvent(event);
      } else {
        console.log("Handling other event");
        handleOtherEvent(event);
      }
    });

    const handleDoneEvent = () => {
      evntSrtm.close();
      this.currentEventSource = null;
      this.setState({
        charCoords: this.codemirror.getCodeMirror().charCoords(this.state.cursorPosition)
      });
      const { line, ch } = this.state.cursorPosition;
      this.codemirror.getCodeMirror().doc.setCursor(line, ch);

      // Use the stored suggestion range if available, otherwise fall back to old logic
      if (this.state.suggestionRange) {
        this.codemirror.getCodeMirror().doc.markText(
          this.state.suggestionRange.from,
          this.state.suggestionRange.to,
          { className: "styled-background" }
        );
      } else {
        this.codemirror.getCodeMirror().doc.markText(
          this.state.cursorPosition,
          { line, ch: ch + this.state.codeSuggestion.length },
          { className: "styled-background" }
        );
      }
    };

    const handleDStartEvent = (event) => {
      let spliced1stEvent = JSON.parse(event.data.substring(6));
      let splicedEvent2 = this.state.mode === "text/plain" ?
        spliced1stEvent.choices[0].text :
        spliced1stEvent.choices[0].delta.content;

      let newOutput = this.state.codeSuggestion + splicedEvent2;
      this.setState({
        codeSuggestion: newOutput
      });
    };

    const handleOtherEvent = (event) => {
      let newEvent = JSON.parse(event.data);
      if (newEvent.text === undefined) return;

      // Get current cursor position
      const { line, ch } = this.state.cursorPosition;

      // Remove previous suggestion mark (if any)
      const cm = this.codemirror.getCodeMirror();
      cm.getAllMarks().forEach(marker => marker.clear());

      // Clear any existing suggestion text
      const currentText = cm.getRange(
        { line, ch },
        { line, ch: ch + (this.state.codeSuggestion ? this.state.codeSuggestion.length : 0) }
      );
      if (currentText) {
        cm.replaceRange("", { line, ch }, { line, ch: ch + currentText.length });
      }

      // Since we're now asking the AI to only complete from cursor forward,
      // we can insert the response directly without filtering
      // But ensure we only get single-line completions
      let insertText = newEvent.text;

      // Debug logging
      console.log("AI returned:", newEvent.text);
      console.log("Cursor position:", { line, ch });
      console.log("Current line text:", cm.getLine(line));

      // If the AI response contains newlines, only take the first line
      if (insertText.includes('\n')) {
        insertText = insertText.split('\n')[0];
      }

      // Insert the completion text
      cm.replaceRange(insertText, { line, ch });

      // Mark the inserted suggestion
      cm.markText(
        { line, ch },
        { line, ch: ch + insertText.length },
        { className: "styled-background" }
      );

      // Store the suggestion range for proper removal
      this.setState({
        codeSuggestion: insertText,
        suggestionRange: {
          from: { line, ch },
          to: { line, ch: ch + insertText.length }
        }
      });
    };


    evntSrtm.addEventListener("error", (error) => {
      console.log(error);
    });
  }

  useHuggingFace = async () => {
    const baseURL = getBaseURL();

    const codeInput = this.state.code;

    // Generate unique ID for this card
    const cardId = `hf_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    let cardCreated = false;

    const hfURL = `${baseURL}/huggingface?language=${this.state.currlang}&sessionid=${this.state.sessionid}&code=${encodeURIComponent(codeInput)}/`;

    try {
      const response = await fetch(hfURL, { method: "GET" });
      const data = await response.text();

      // Skip empty responses
      if (!data || data.trim() === '') {
        return;
      }

      // Process the response text character by character for typewriter effect
      const characters = data.split("");
      let charIndex = 0;

      const typewriterInterval = setInterval(() => {
        if (charIndex >= characters.length) {
          clearInterval(typewriterInterval);
          return;
        }

        const char = characters[charIndex];
        this.setState(prevState => {
          const currentCards = [...prevState.cards];
          const cardIndex = currentCards.findIndex(card => card.id === cardId);

          if (cardIndex !== -1) {
            // Update existing card
            currentCards[cardIndex] = {
              ...currentCards[cardIndex],
              output: currentCards[cardIndex].output + char
            };
          } else if (!cardCreated) {
            // Create card only when first character arrives
            currentCards.unshift({
              id: cardId,
              output: char,
              time: new Date().toLocaleString(),
              model: "hf"
            });
            cardCreated = true;
          }
          return { cards: currentCards };
        });

        charIndex++;
      }, 10);

    } catch (error) {
      console.error('Error fetching HuggingFace response:', error);
    }
  }

  useGemini = () => {
    // Cancel any existing EventSource (Gemini or completion)
    if (this.currentEventSource) {
      this.currentEventSource.close();
      this.currentEventSource = null;
    }

    const baseURL = getBaseURL();
    const codeInput = this.state.code;

    const cardId = `gemini_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    let cardCreated = false;

    this.currentEventSource = new EventSource(`${baseURL}/gemini?language=${this.state.currlang}&sessionid=${this.state.sessionid}&code=${encodeURIComponent(codeInput)}/`);
    const eventStream = this.currentEventSource;

    eventStream.addEventListener("message", (event) => {
      try {
        const data = event.data;
        if (data === '[DONE]') {
          eventStream.close();
          this.currentEventSource = null;
          return;
        }

        const parsedData = JSON.parse(data);
        if (parsedData.text) {
          this.setState(prevState => {
            const currentCards = [...prevState.cards];
            const cardIndex = currentCards.findIndex(card => card.id === cardId);

            if (cardIndex !== -1) {
              currentCards[cardIndex] = {
                ...currentCards[cardIndex],
                output: (currentCards[cardIndex].output || "") + parsedData.text
              };
            } else if (!cardCreated) {
              currentCards.unshift({
                id: cardId,
                output: parsedData.text,
                time: new Date().toLocaleString(),
                model: "Google Gemini"
              });
              cardCreated = true;
            }
            return { cards: currentCards };
          });
        }
      } catch (error) {
        console.error('Error processing Gemini response:', error);
      }
    });

    eventStream.addEventListener("error", (error) => {
      console.error('Gemini EventStream Error:', error);
      eventStream.close();
      this.currentEventSource = null;
    });
  }


  usePaLM = async () => {
    const baseURL = getBaseURL();
    const codeInput = this.state.code;

    // Generate unique ID for this card
    const cardId = `palm_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    let cardCreated = false;

    const palmURL = `${baseURL}/palm?language=${this.state.currlang}&sessionid=${this.state.sessionid}&code=${encodeURIComponent(codeInput)}/`;

    try {
      const response = await fetch(palmURL, { method: "GET" });
      const data = await response.text();

      // Process the response text character by character for typewriter effect
      const characters = data.split("");
      let charIndex = 0;

      const typewriterInterval = setInterval(() => {
        if (charIndex >= characters.length) {
          clearInterval(typewriterInterval);
          return;
        }

        const char = characters[charIndex];
        this.setState(prevState => {
          const currentCards = [...prevState.cards];
          const cardIndex = currentCards.findIndex(card => card.id === cardId);

          if (cardIndex !== -1) {
            // Update existing card
            currentCards[cardIndex] = {
              ...currentCards[cardIndex],
              output: currentCards[cardIndex].output + char
            };
          } else if (!cardCreated) {
            // Create card only when first character arrives
            currentCards.unshift({
              id: cardId,
              output: char,
              time: new Date().toLocaleString(),
              model: "Google PaLM"
            });
            cardCreated = true;
          }
          return { cards: currentCards };
        });

        charIndex++;
      }, 1); // Faster animation for PaLM

    } catch (error) {
      console.error('Error fetching PaLM response:', error);
    }
  }

  useAnthropic = () => {
    const baseURL = getBaseURL();

    let codeInput = this.state.code;

    // Generate unique ID for this card
    const cardId = `anthropic_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    let cardCreated = false;

    // Start the EventSource connection
    const eventStream = new EventSource(`${baseURL}/anthropic?language=${this.state.currlang}&sessionid=${this.state.sessionid}&code=${encodeURIComponent(codeInput)}/`);

    eventStream.addEventListener("message", (event) => {
      try {
        const eventData = JSON.parse(event.data);
        if (eventData.text) {
          this.setState(prevState => {
            const currentCards = [...prevState.cards];
            // Find the specific card for this response by ID
            const cardIndex = currentCards.findIndex(card => card.id === cardId);

            if (cardIndex !== -1) {
              // Update existing card
              currentCards[cardIndex] = {
                ...currentCards[cardIndex],
                output: [...currentCards[cardIndex].output, eventData.text]
              };
            } else if (!cardCreated) {
              // Create new card only when first content arrives
              currentCards.unshift({
                id: cardId,
                output: [eventData.text],
                time: new Date().toLocaleString(),
                model: "anthropic"
              });
              cardCreated = true;
            }
            return { cards: currentCards };
          });
        }
      } catch (error) {
        console.error('Error processing Anthropic response:', error);
      }
    });

    eventStream.addEventListener("error", (error) => {
      console.error('EventStream Error:', error);
      eventStream.close();
    });

    // Clean up when component unmounts
    return () => {
      eventStream.close();
    };
  };

  useOpenAI = () => {
    const baseURL = getBaseURL();

    let codeInput = this.state.code;

    // Generate unique ID for this card
    const cardId = `openai_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    let cardCreated = false;

    let evntSrtm = new EventSource(`${baseURL}/openai?language=${this.state.currlang}&sessionid=${this.state.sessionid}&code=${encodeURIComponent(codeInput)}/`);

    evntSrtm.addEventListener("message", (event) => {
      const { data } = event;

      if (data === '[DONE]') {
        evntSrtm.close();
        return;
      }

      try {
        const parsedData = JSON.parse(data);
        if (parsedData.text) {
          this.setState(prevState => {
            const currentCards = [...prevState.cards];
            // Find the specific card for this response by ID
            const cardIndex = currentCards.findIndex(card => card.id === cardId);

            if (cardIndex !== -1) {
              // Update existing card
              currentCards[cardIndex] = {
                ...currentCards[cardIndex],
                output: (currentCards[cardIndex].output || "") + parsedData.text
              };
            } else if (!cardCreated) {
              // Create new card only when first content arrives
              currentCards.unshift({
                id: cardId,
                output: parsedData.text,
                time: new Date().toLocaleString(),
                model: "openai"
              });
              cardCreated = true;
            }
            return { cards: currentCards };
          });
        }
      } catch (error) {
        console.error('Error parsing OpenAI response:', error);
      }
    });

    evntSrtm.addEventListener("error", (error) => {
      console.error('EventSource error:', error);
      evntSrtm.close();
    });
  };

  closeCard(index) {
    if (index > -1) {
      const newCards = [...this.state.cards];
      newCards.splice(index, 1);
      this.setState({ cards: newCards });
    }
  }

  copyCard(index) {
    const cardCopy = this.state.cards[index].output.join("");
    navigator.clipboard.writeText(cardCopy);
    return (
      <div>
        <p>copied to clipboard</p>
      </div>
    );
  }


  mapCards() {
    const { cards } = this.state;
    const { darkMode } = this.props;

    const cardInfo = cards.map((card, index) => (
      <Card
        key={card.id || index} // Use unique ID as key when available
        index={index}
        cardId={card.id}
        output={card.output}
        cardCreated={card.time}
        model={card.model}
        darkMode={darkMode}
        closeCard={this.closeCard}
        copyCard={this.copyCard}
      />
    ));

    return (
      <RemoveScroll className="poweredBy scroll">
        <div className="cards-container">
          {cardInfo}
        </div>
        <div ref={this.cardsEndRef} />
      </RemoveScroll>
    );
  }


  handleAiCardWheel(e) {
    const el = this.aiCardRef.current;
    if (el) {
      e.preventDefault();
      e.stopPropagation();
      let deltaY = e.deltaY;
      if (e.deltaMode === WheelEvent.DOM_DELTA_LINE) {
        const lineHeight = parseInt(getComputedStyle(el).lineHeight, 10);
        deltaY *= (Number.isNaN(lineHeight) ? 40 : lineHeight);
      } else if (e.deltaMode === WheelEvent.DOM_DELTA_PAGE) {
        deltaY *= el.clientHeight;
      }
      el.scrollTop += deltaY;
    }
  }

  poweredBy() {
    if (this.state.cards.length && this.state.currlang !== " plntxt") {
      return <div>
        {/* <div className="poweredBy">Usage: </div> */}
        {/* <div className="poweredBy">Completion {this.state.usage.completion_tokens}</div>
        <div className="poweredBy">Prompt {this.state.usage.prompt_tokens}</div>
        <div className="poweredBy">Total {this.state.usage.total_tokens}</div> */}
        <div className="codex poweredBy neonText">Codex</div>
      </div>
    } else if (this.state.cards.length && this.state.currlang === " plntxt") {
      return <div>
        {/* <div className="poweredBy">Usage: </div> */}
        {/* <div className="poweredBy">Completion {this.state.usage.completion_tokens}</div>
        <div className="poweredBy">Prompt {this.state.usage.prompt_tokens}</div>
        <div className="poweredBy">Total {this.state.usage.total_tokens}</div> */}
        <div className="codex poweredBy neonText">GPT-3</div>
      </div>
    }
  };

  // The Judge0 API is used to evaluste the users code,
  // there are two steps to that. 1-A code submission (POST request) is
  // made, and the response is a token. Then that token is used in a GET
  // request to return the result of the code execution. I split this
  // between the runCode() and useToken functions.
  async runCode() {
    // Remove throttling - allow unlimited runs for all users
    // if (!this.state.isPrivate && !this.state.login) {
    //   this.runCodeThrottle();
    //   return;
    // }

    this.setState({ loading: true });
    const baseURL = getBaseURL();

    const handleResponseData = (data) => {
      let sessionid2 = this.state.sessionid;
      this.setState({ history: Object.assign(this.state.history, { [sessionid2]: new Date().toLocaleString() }) });
      localStorage.setItem("history", JSON.stringify(this.state.history));
      localStorage.setItem("prevBoard", JSON.stringify(this.state.sessionid));

      if (data.stdout) {
        let evalOutput = data.stdout;
        let compileOutput = data.compile_output;
        let errOut = data.stderr;
        let time = data.time;
        let memory = data.memory;

        const outputToStore = errOut == null ? evalOutput : evalOutput + errOut;
        const updatedState = errOut == null
          ? { evalOutput: evalOutput, compileOutput: compileOutput, errOut: errOut, loading: false, time: time, memory: memory }
          : { evalOutput: evalOutput + errOut, compileOutput: compileOutput, loading: false };

        this.setState(updatedState, () => {
          // console.log("State after runCode update:", this.state.evalOutput);

          // Update sessionStorage with the fresh output
          sessionStorage.setItem("evalOutput", this.state.evalOutput);
          sessionStorage.setItem("compileOutput", this.state.compileOutput);
          sessionStorage.setItem("errOut", errOut);

          // Also clear any old database output from state and sessionStorage to ensure fresh output takes precedence
          this.setState({ evalOutputDB: null });
          sessionStorage.removeItem("evalOutputDB");
        });

        // Persist to DB using local output (setState is async - this.state would be stale here)
        const dbRef = ref(this.db);
        const auth = getAuth();
        const user = auth.currentUser;

        if (this.state.isPrivate && user) {
          update(child(dbRef, `private-sandboxes/${user.uid}/${this.state.sessionid}`), {
            evalOutput: "" + outputToStore,
            compileOutput: "" + compileOutput,
          });
        } else {
          update(child(dbRef, `code-sessions/${this.state.sessionid}`), {
            evalOutput: "" + outputToStore,
            compileOutput: "" + compileOutput,
          });
        }
      } else if (data.stdout == null) {
        let errOut = data.stderr;
        let time = data.time;
        let memory = data.memory;

        console.log("Setting error output:", errOut);

        this.setState(prevState => ({
          evalOutput: errOut,
          loading: false,
          time: time,
          memory: memory,
          compileOutput: prevState.compileOutput,
          evalOutputDB: null // Clear old database output
        }), () => {
          console.log("State after error update:", this.state.evalOutput);

          // Update sessionStorage with error output
          sessionStorage.setItem("evalOutput", errOut);
          sessionStorage.setItem("errOut", errOut);

          // Also clear old database output from sessionStorage
          sessionStorage.removeItem("evalOutputDB");

          // Persist error output to DB so it's restored on reload
          const dbRef = ref(this.db);
          const auth = getAuth();
          const user = auth.currentUser;

          if (this.state.isPrivate && user) {
            update(child(dbRef, `private-sandboxes/${user.uid}/${this.state.sessionid}`), {
              evalOutput: "" + this.state.evalOutput,
              compileOutput: "" + (this.state.compileOutput || ""),
            });
          } else {
            update(child(dbRef, `code-sessions/${this.state.sessionid}`), {
              evalOutput: "" + this.state.evalOutput,
              compileOutput: "" + (this.state.compileOutput || ""),
            });
          }
        });
      }
    }

    if (this.state.openAiToggle) this.useOpenAI();
    if (this.state.flanT5Toggle) this.useHuggingFace();
    if (this.state.anthropicToggle) this.useAnthropic();
    if (this.state.GrokAIToggle) this.useGrokAI();
    if (this.state.GeminiToggle) this.useGemini();

    const judge0URL = `${baseURL}/judge0?language_id=${this.state.language_id}&sessionid=${this.state.sessionid}&code=${encodeURIComponent(this.state.code)}`;

    try {
      const response = await fetch(judge0URL, {
        method: "GET",
        params: { base64_encoded: 'true', fields: '*' },
      });
      const data = await response.json();
      handleResponseData(data);
    } catch (err) {
      console.log(err);
      this.setState({ loading: false });
    }

    this.updateUserSessionLastAccessed();
  }


  toggleExtend() {
    this.setState(prevState => ({ evalExtend: !prevState.evalExtend }));
  }


  toggleTimer() {
    this.setState(prevState => ({ timerExtend: !prevState.timerExtend }));
  }


  toggleWhiteboard() {
    const newWhiteboardExtendValue = !this.state.whiteboardExtend;

    this.setState({ whiteboardExtend: newWhiteboardExtendValue });
    sessionStorage.setItem("whiteboardExtend", newWhiteboardExtendValue.toString());
  }

  setActiveTab(tab) {
    this.setState({ activeTab: tab });
    // Emit tab switch so others know where we are (for unified cursor presence)
    if (this.socket && this.socket.connected && this.state.yourID && this.state.sessionid) {
      if (tab === 'diagram') {
        this.socket.emit('cursor-update', {
          sessionid: this.state.sessionid,
          position: null,
          selection: null,
          activeTab: 'diagram'
        });
      } else {
        // Switching to code - send position and request others' cursors so they show immediately
        this.socket.emit('cursor-update', {
          sessionid: this.state.sessionid,
          position: this.state.cursorPosition,
          selection: null,
          activeTab: 'code'
        });
        this.socket.emit('request-cursor-positions', { sessionid: this.state.sessionid });
      }
    }
  }

  setDiagramCollaborationOn(on) {
    this.setState({ diagramCollaborationOn: on });
  }

  toggleBorder() {
    const newBorderToggleValue = !this.state.borderToggle;
    this.setState({ borderToggle: newBorderToggleValue });
    sessionStorage.setItem("borderToggle", newBorderToggleValue.toString());
  }

  toggleOpenAI() {
    const newOpenAiToggleValue = !this.state.openAiToggle;

    this.setState({ openAiToggle: newOpenAiToggleValue });
    sessionStorage.setItem("openAiToggle", newOpenAiToggleValue.toString());
  }


  toggleCompletion() {
    const newCompletionToggleValue = !this.state.completionToggle;
    this.setState({ completionToggle: newCompletionToggleValue });
    sessionStorage.setItem("completionToggle", newCompletionToggleValue.toString());
  }


  toggleFlanT5() {
    const newFlanT5ToggleValue = !this.state.flanT5Toggle;

    this.setState({ flanT5Toggle: newFlanT5ToggleValue });
    sessionStorage.setItem("flanT5Toggle", newFlanT5ToggleValue.toString());
  }


  toggleAnthropic() {
    const newAnthropicToggleValue = !this.state.anthropicToggle;

    this.setState({ anthropicToggle: newAnthropicToggleValue });
    sessionStorage.setItem("anthropicToggle", newAnthropicToggleValue.toString());
  }

  togglePaLM() {
    const newPaLMToggleValue = !this.state.PaLMToggle;
    this.setState({ PaLMToggle: newPaLMToggleValue });
    sessionStorage.setItem("PaLMToggle", newPaLMToggleValue.toString());
  }

  toggleGemini() {
    const newGeminiToggleValue = !this.state.GeminiToggle;

    this.setState({ GeminiToggle: newGeminiToggleValue });
    sessionStorage.setItem("GeminiToggle", newGeminiToggleValue.toString());
  }

  toggleGrokAI() {
    const newGrokAIToggleValue = !this.state.GrokAIToggle;
    this.setState({ GrokAIToggle: newGrokAIToggleValue });
    sessionStorage.setItem("GrokAIToggle", newGrokAIToggleValue.toString());
  }


  // toggleBorder() {
  //   const newBorderToggleValue = !this.state.borderToggle;

  //   this.setState({ borderToggle: newBorderToggleValue });
  //   sessionStorage.setItem("borderToggle", newBorderToggleValue.toString());
  // }


  //Lets you select between JS, Python, Ruby
  toggleLanguage(id, key, mode) {
    // Shallow copy of the array/object from state using the key
    const temp = Array.isArray(this.state[key]) ? [...this.state[key]] : { ...this.state[key] };

    temp[id].selected = !temp[id].selected;
    const newMode = temp[id];
    const { mode: newModeMode, language_id, title } = newMode;

    this.setState({
      [key]: temp,
      mode: newModeMode,
      language_id,
      currlang: title,
    });

    // Store in sessionStorage
    sessionStorage.setItem(key, JSON.stringify(temp));
    sessionStorage.setItem("mode", newModeMode);
    sessionStorage.setItem("language_id", language_id.toString());
    sessionStorage.setItem("currlang", title);

    // Store in Firebase if we have a session
    if (this.state.sessionid) {
      const dbRef = ref(this.db);
      const auth = getAuth();
      const user = auth.currentUser;

      if (this.state.isPrivate && user) {
        // Write to private-sandboxes for authenticated users
        update(child(dbRef, `private-sandboxes/${user.uid}/${this.state.sessionid}`), {
          language: title,
          language_id: language_id,
          mode: newModeMode
        });
      } else {
        // Write to code-sessions for non-authenticated users or public sandboxes
        update(child(dbRef, `code-sessions/${this.state.sessionid}`), {
          language: title,
          language_id: language_id,
          mode: newModeMode
        });
      }
    }
  }


  //To keep track of where the cursor is currently
  changeCursorPos = () => {
    const { line, ch } = this.state.cursorPosition;
    this.codemirror.getCodeMirror().doc.setCursor(line, ch);
  };

  //This is where the code editor handles changes from user input
  onChange = (newVal, change) => {
    if (!this.codemirror || !this.codemirror.getCodeMirror()) {
      return;
    }

    const cm = this.codemirror.getCodeMirror();
    const doc = cm.doc;

    // Set typing flag
    this.isTyping = true;
    clearTimeout(this.typingTimeout);
    this.typingTimeout = setTimeout(() => {
      this.isTyping = false;
    }, 1000); // Consider typing finished after 1 second of no changes

    if (!change.origin) {
      this.setState({ charCoords: undefined });
      return;
    }

    const suffix = cm.getRange(doc.getCursor(), {
      line: doc.lineCount(),
      ch: 0
    });

    const newState = {
      suffix,
      code: newVal
    };

    if (this.state.completionToggle) {
      newState.codeSuggestion = "";
      clearTimeout(this.inputTimer);
      this.inputTimer = setTimeout(() => {
        this.aiCompletion();
      }, 1500);
    }

    this.setState(newState);

    // Debounce Firebase updates during typing
    clearTimeout(this.firebaseUpdateTimeout);
    this.firebaseUpdateTimeout = setTimeout(() => {
      const dbRef = ref(this.db);
      const auth = getAuth();
      const user = auth.currentUser;

      if (this.state.isPrivate && user) {
        // Write to private-sandboxes for authenticated users
        update(child(dbRef, `private-sandboxes/${user.uid}/${this.state.sessionid}`), {
          content: newVal
        });
      } else {
        // Write to code-sessions for non-authenticated users or public sandboxes
        update(child(dbRef, `code-sessions/${this.state.sessionid}`), {
          content: newVal
        });
      }
    }, 500);
  };

  whiteboardRender() {
    const whiteboardExtendFromState = this.state.whiteboardExtend;
    const whiteboardExtendFromSession = sessionStorage.getItem("whiteboardExtend") === "true";
    const borderToggleFromState = this.state.borderToggle;
    const borderToggleFromSession = sessionStorage.getItem("borderToggle") === "true";
    const darkMode = this.props.darkMode;

    // Determine if panel should be visible
    const isPanelVisible = whiteboardExtendFromState || whiteboardExtendFromSession;

    let handleWrapperClass = "";

    if (borderToggleFromState || borderToggleFromSession) {
      handleWrapperClass = darkMode ? "borderOn-dark" : "borderOn";
    } else {
      handleWrapperClass = darkMode ? "handleToggle-dark" : "handleToggle";
    }

    // Always render the component but hide it when panel is closed
    // This keeps the LiveKit connection alive
    return (
      <div
        ref={(el) => { this.agentPanelRef = el; }}
        style={{ display: isPanelVisible ? 'block' : 'none' }}
        className="agent-panel-wrapper"
      >
        <Resizable
          handleWrapperClass={handleWrapperClass}
          handleStyles={{ left: { left: 0 } }}
          enable={{ left: true }}
          minWidth="25vw"
          maxWidth="80vw"
          onResize={(e, direction, ref) => {
            if (ref && ref.offsetWidth) {
              this.setState({ agentPanelWidthPx: ref.offsetWidth });
            }
          }}
          onResizeStop={(e, direction, ref) => {
            if (ref && ref.offsetWidth) {
              this.setState({ agentPanelWidthPx: ref.offsetWidth });
            }
          }}
        >
          <RemoveScroll>
            <div
              className="witeboard blank-whiteboard"
              style={{ position: 'relative' }}
            >
              {this.state.creditsCanStart === false && (
                <div
                  className="credits-blocked-overlay"
                  style={{
                    position: 'absolute',
                    inset: 0,
                    background: 'rgba(0,0,0,0.85)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 1000,
                    padding: 24,
                    textAlign: 'center'
                  }}
                >
                  <p style={{ fontSize: '1.1rem', marginBottom: 8 }}>
                    This interview is temporarily unavailable.
                  </p>
                  <p style={{ opacity: 0.9 }}>
                    The hiring team needs to add credits to continue. Please ask them to purchase more credits.
                  </p>
                </div>
              )}
              <LiveKitAgent
                sessionId={this.props.sessionid || this.state.sessionid}
                darkMode={darkMode}
                codeContent={this.state.code}
                compilerOutput={this.state.evalOutput || this.state.compileOutput}
                language={this.state.currlang}
                participantCount={this.state.members.length}
                interviewContext={this.state.interviewContext}
                diagramContent={this.state.diagramContent}
              />
            </div>
          </RemoveScroll>
        </Resizable>
      </div>
    );
  }

  login() {
    this.props.navigate("/login");
  };

  logout() {
    const auth = getAuth();
    signOut(auth).then(() => {
      // Sign-out successful.
      this.setState({
        login: false,
      })
      console.log("logout");
    }).catch((error) => {
      // An error happened.
    });
  }

  loginRender() {
    const { login } = this.state;
    const iconStyle = {
      size: "1.35em",
      style: {
        paddingRight: "0.2rem",
        marginTop: "0.1rem"
      }
    };

    return (
      <div
        className="loginBtn"
        title={login ? "logout" : "login"}
        onClick={login ? this.logout.bind(this) : this.login.bind(this)}
      >
        <IconContext.Provider value={iconStyle}>
          {login ? <CiLogout /> : <CiLogin />}
        </IconContext.Provider>
      </div>
    );
  }


  toolTipRender() {
    if (this.state.charCoords) {
      if (this.codemirror.getCodeMirror().doc.getAllMarks().length > 0) {
        return <div className="tooltip" style={{ top: this.codemirror.getCodeMirror().heightAtLine(this.state.cursorPosition.line) - 4.2, left: this.state.charCoords.left }}>
          <div className="tooltip-text">
            <div className="tooltip-shift-tab tooltip-text" onClick={this.acceptSuggestion.bind(this)}>
              SHIFT + TAB to Accept |
            </div>
            <div className="tooltip-escape tooltip-text" onClick={this.denySuggestion.bind(this)}>
              | ESC to Deny
            </div>
          </div>
        </div>
      }
    }
  }

  acceptSuggestion() {
    if (this.state.codeSuggestion && this.state.suggestionRange) {
      const codeMirrorInstance = this.codemirror.getCodeMirror().doc;
      // Clear all marks (visual highlighting)
      codeMirrorInstance.getAllMarks().forEach(marker => marker.clear());
      // Move cursor to end of accepted suggestion
      codeMirrorInstance.setCursor(
        this.state.suggestionRange.to.line,
        this.state.suggestionRange.to.ch
      );
      // Clear state to hide tooltip
      this.setState({
        charCoords: undefined,
        codeSuggestion: "",
        suggestionRange: undefined
      });
    }
  }


  denySuggestion() {
    if (this.state.codeSuggestion && this.state.suggestionRange) {
      const codeMirrorInstance = this.codemirror.getCodeMirror().doc;
      // Clear all marks (visual highlighting)
      codeMirrorInstance.getAllMarks().forEach(marker => marker.clear());
      // Clear the suggestion text using the stored range
      codeMirrorInstance.replaceRange("",
        this.state.suggestionRange.from,
        this.state.suggestionRange.to
      );
      // Clear state to hide tooltip and suggestion
      this.setState({
        charCoords: undefined,
        codeSuggestion: "",
        suggestionRange: undefined
      });
    }
  }

  updateTranscript = (newTranscript) => {
    if (newTranscript !== "") {
      console.log("transcript in state: ", newTranscript);

      this.setState((prevState) => {
        const updatedCards = [...prevState.cards];

        // Check if the previous card's model is 'assistant'
        if (updatedCards.length > 0 && updatedCards[0].model === 'assistant') {
          // Add the new transcript with highlight and ensure a new line is at the end
          updatedCards[0].output.push(`<span class="highlight">${newTranscript}</span>\n\n`);
        } else {
          // Generate unique ID for this card
          const cardId = `assistant_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;

          // Create a new card with the transcript data, highlight, and a line break
          const newCard = {
            id: cardId,
            output: [`<span class="highlight">${newTranscript}</span>\n\n`],
            time: new Date().toLocaleString(),
            model: 'assistant',
          };
          // Add the new card to the existing cards
          updatedCards.unshift(newCard);
        }

        return { cards: updatedCards };
      }, this.scrollToBottom);
    }
  };

  scrollToBottom() {
    if (this.cardsEndRef.current) {
      this.cardsEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }

  useGrokAI = () => {
    const baseURL = getBaseURL();

    let codeInput = this.state.code;

    // Generate unique ID for this card
    const cardId = `grok_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    let cardCreated = false;

    let evntSrtm = new EventSource(`${baseURL}/grok?language=${this.state.currlang}&sessionid=${this.state.sessionid}&code=${encodeURIComponent(codeInput)}/`);

    evntSrtm.onopen = () => {
      // console.log('Grok AI EventSource connection opened');
    };

    evntSrtm.addEventListener("message", (event) => {
      const { data } = event;
      // console.log("Grok AI data: ", data);

      if (data === '[DONE]') {
        evntSrtm.close();
        return;
      }

      try {
        const parsedData = JSON.parse(data);

        // Only handle content when it arrives, don't create empty cards
        if (parsedData.content) {
          this.setState(prevState => {
            const currentCards = [...prevState.cards];
            const cardIndex = currentCards.findIndex(card => card.id === cardId);

            if (cardIndex !== -1) {
              // Update existing card
              currentCards[cardIndex] = {
                ...currentCards[cardIndex],
                output: (currentCards[cardIndex].output || "") + parsedData.content
              };
            } else if (!cardCreated) {
              // Create card only when first content arrives
              currentCards.unshift({
                id: cardId,
                output: parsedData.content,
                time: new Date().toLocaleString(),
                model: "Grok AI"
              });
              cardCreated = true;
            }
            return { cards: currentCards };
          });
        } else if (parsedData.type === "error") {
          console.error("Grok AI Error:", parsedData.error, parsedData.details);
        }
      } catch (error) {
        console.error('Error parsing Grok AI response:', error);
      }
    });

    evntSrtm.addEventListener("error", (error) => {
      console.error('Grok AI EventSource error:', error);
      evntSrtm.close();
    });
  };

  updateUserSessionLastAccessed = () => {
    const auth = getAuth();
    const user = auth.currentUser;
    const db = getDatabase();
    const sessionId = this.state.sessionid;
    if (user && sessionId) {
      const userId = user.uid;
      if (this.state.isPrivate) {
        // Update lastAccessed in private-sandboxes (ISO string for reliable sorting)
        update(ref(db, `private-sandboxes/${userId}/${sessionId}`), {
          lastAccessed: new Date().toISOString()
        });
      } else {
        // Update lastAccessed in code-sessions
        update(ref(db, `code-sessions/${sessionId}`), {
          lastAccessed: new Date().toISOString()
        });
      }
    }
  };

  // Anti-abuse methods
  checkAbuseLimits() {
    const now = Date.now();
    const oneMinute = 60 * 1000;

    // Check for excessive code runs (only for public sandboxes)
    if (!this.state.isPrivate && !this.state.login) {
      if (now - this.state.lastRunTime < oneMinute) {
        this.setState(prevState => ({ runCount: prevState.runCount + 1 }));

        if (this.state.runCount > 8) { // Warn at 8 runs per minute
          this.showAbuseWarning('You\'re running code very frequently. Consider slowing down or signing up for higher limits.');
          return false;
        }
      } else {
        this.setState({ runCount: 1, lastRunTime: now });
      }
    }

    return true;
  }

  showAbuseWarning(message) {
    this.setState({ abuseWarning: message });

    // Clear warning after 5 seconds
    setTimeout(() => {
      this.setState({ abuseWarning: null });
    }, 5000);
  }

  runCodeThrottle() {
    if (!this.checkAbuseLimits()) {
      return;
    }

    // Proceed with normal runCode
    this.runCode();
  }

  // Share functionality methods
  generateShareLink() {
    const baseURL = window.location.origin;
    const sessionId = this.state.sessionid;

    if (!sessionId) return `${baseURL}/box/`;

    if (this.state.isPrivate && this.state.login) {
      // For private sandboxes, include user info
      const auth = getAuth();
      const user = auth.currentUser;
      return `${baseURL}/box/${sessionId}?private=1&user=${user?.uid || ''}`;
    } else {
      // For public sandboxes - /box/:sessionid is the correct route
      return `${baseURL}/box/${sessionId}`;
    }
  }

  openShareModal() {
    const shareLink = this.generateShareLink();
    this.setState({
      showShareModal: true,
      shareLink: shareLink,
      copySuccess: false
    });
  }

  closeShareModal() {
    this.setState({
      showShareModal: false,
      shareLink: "",
      copySuccess: false
    });
  }

  async copyToClipboard() {
    try {
      await navigator.clipboard.writeText(this.state.shareLink);
      this.setState({ copySuccess: true });

      // Reset success message after 2 seconds
      setTimeout(() => {
        this.setState({ copySuccess: false });
      }, 2000);
    } catch (err) {
      console.error('Failed to copy: ', err);
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = this.state.shareLink;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);

      this.setState({ copySuccess: true });
      setTimeout(() => {
        this.setState({ copySuccess: false });
      }, 2000);
    }
  }

  async togglePrivacy() {
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
      alert('You must be logged in to make sandboxes private');
      return;
    }

    const dbRef = ref(this.db);
    const sessionId = this.state.sessionid;
    const userId = user.uid;

    try {
      if (this.state.isPrivate) {
        // Convert from private to public
        // First, get the private sandbox data
        const privateSnapshot = await get(ref(this.db, `private-sandboxes/${userId}/${sessionId}`));
        if (privateSnapshot.exists()) {
          const privateData = privateSnapshot.val();

          // Copy to public sandboxes
          await set(ref(this.db, `code-sessions/${sessionId}`), {
            ...privateData,
            convertedFromPrivate: true,
            originalOwner: userId
          });

          // Remove from private sandboxes
          await remove(ref(this.db, `private-sandboxes/${userId}/${sessionId}`));

          // Update state
          this.setState({ isPrivate: false });

          // Update share link
          this.generateShareLink();
        }
      } else {
        // Convert from public to private
        // First, get the public sandbox data
        const publicSnapshot = await get(ref(this.db, `code-sessions/${sessionId}`));
        if (publicSnapshot.exists()) {
          const publicData = publicSnapshot.val();

          // Copy to private sandboxes
          await set(ref(this.db, `private-sandboxes/${userId}/${sessionId}`), {
            ...publicData,
            convertedFromPublic: true,
            convertedAt: new Date().toLocaleString()
          });

          // Remove from public sandboxes
          await remove(ref(this.db, `code-sessions/${sessionId}`));

          // Update state
          this.setState({ isPrivate: true });

          // Update share link
          this.generateShareLink();
        }
      }
    } catch (error) {
      console.error('Error toggling privacy:', error);
      alert('Failed to change privacy setting. Please try again.');
    }
  }

  updatePresence(members, yourID) {
    this.setState({ members, yourID }, () => {
      // Send our current cursor position and request positions from others
      if (this.socket && this.socket.connected && yourID && this.state.sessionid) {
        // Send our current cursor position so others can see it
        if (this.codemirror && this.codemirror.getCodeMirror()) {
          const cm = this.codemirror.getCodeMirror();
          const cursorPosition = cm.getCursor();
          const hasSelection = cm.somethingSelected() ? {
            anchor: cm.getCursor('anchor'),
            head: cm.getCursor('head')
          } : null;

          // Send our current position immediately
          this.socket.emit('cursor-update', {
            sessionid: this.state.sessionid,
            position: cursorPosition,
            selection: hasSelection,
            activeTab: 'code'
          });
        }

        // Request cursor positions for all other members
        const otherMembers = members.filter(m => m.id !== yourID);
        if (otherMembers.length > 0) {
          this.socket.emit('request-cursor-positions', {
            sessionid: this.state.sessionid
          });
        }
      }
    });
  }

  // Handle socket ready from VideoChat (reuse the same socket)
  initializeSocket(sessionid) {
    if (this.socket) return; // Already initialized

    const baseURL = getBaseURL();
    this.socket = io(baseURL, {
      transports: ['websocket', 'polling'],
      withCredentials: true,
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      timeout: 20000,
      forceNew: true,
      path: '/socket.io/',
      autoConnect: false
    });

    this.socket.on('connect', async () => {
      let userDetails = {};
      try {
        const auth = getAuth();
        // Wait for auth state to be ready (handles async restore from persisted session).
        // Without this, currentUser can be null when socket connects before Firebase restores the session,
        // causing presence indicators to show a random name instead of the logged-in user's name.
        const currentUser = await new Promise((resolve) => {
          const unsub = onAuthStateChanged(auth, (user) => {
            unsub();
            resolve(user);
          });
        });
        if (currentUser) {
          userDetails.displayName = currentUser.displayName || currentUser.email || null;
          userDetails.photoURL = currentUser.photoURL || null;
        } else {
          try {
            const storedName = localStorage.getItem('anonymousUserName');
            const storedColor = localStorage.getItem('anonymousUserColor');
            if (storedName) userDetails.name = storedName;
            if (storedColor) userDetails.color = storedColor;
          } catch (e) {
            console.log('Could not read stored user identity:', e);
          }
        }
      } catch (error) {
        console.log('Could not get user info:', error);
      }

      this.socket.emit('join-session', {
        sessionid: sessionid,
        userDetails: userDetails
      });
    });

    this.socket.on('yourID', (id) => {
      this.setState({ yourID: id }, () => {
        if (this.state.members?.length > 0) {
          this.updatePresence(this.state.members, id);
        }
      });
    });

    this.socket.on('allUsers', (members) => {
      this.setState({ members }, () => {
        const yourID = this.state.yourID || this.socket?.id;
        if (yourID && members?.length > 0) {
          this.updatePresence(members, yourID);
        }
        if (this.cursorRequestInterval) clearInterval(this.cursorRequestInterval);
        if (members?.length > 1) {
          this.cursorRequestInterval = setInterval(() => {
            if (this.socket?.connected && this.state.sessionid && this.state.activeTab === 'code') {
              this.socket.emit('request-cursor-positions', { sessionid: this.state.sessionid });
            }
          }, 3000);
        }
      });
      const auth = getAuth();
      if (!auth.currentUser) {
        const ourMember = members.find(m => m.id === this.socket?.id);
        if (ourMember && ourMember.isAnonymous) {
          try {
            localStorage.setItem('anonymousUserName', ourMember.name);
            localStorage.setItem('anonymousUserColor', ourMember.color);
          } catch (e) { /* ignore */ }
        }
      }
    });

    this.socket.on('user-joined', (data) => {
      const members = data.allMembers || [];
      this.setState({ members }, () => {
        const yourID = this.state.yourID || this.socket?.id;
        if (yourID && members.length > 0 && this.socket?.connected && this.state.sessionid) {
          this.socket.emit('request-cursor-positions', { sessionid: this.state.sessionid });
        }
      });
    });

    this.socket.on('user-left', (data) => {
      const remaining = data.remainingMembers || [];
      this.setState({ members: remaining });
      if (remaining.length < 2 && this.cursorRequestInterval) {
        clearInterval(this.cursorRequestInterval);
        this.cursorRequestInterval = null;
      }
      if (data.memberId) {
        this.removeRemoteCursor(data.memberId);
        this.removeRemoteSelection(data.memberId);
        for (const [userId, socketId] of this.userCursors.entries()) {
          if (socketId === data.memberId) {
            this.userCursors.delete(userId);
            break;
          }
        }
        this.setState((prev) => {
          const next = { ...prev.memberActiveTabs };
          delete next[data.memberId];
          return { memberActiveTabs: next };
        });
      }
    });

    this.socket.on('connect_error', (error) => {
      console.error('Socket connection error:', error);
    });

    // Cursor tracking events
    this.socket.on('remote-cursor-update', (data) => {
      this.handleRemoteCursorUpdate(data);
    });
    this.socket.on('remote-selection-update', (data) => {
      this.handleRemoteSelectionUpdate(data);
    });
    this.socket.on('remote-selection-clear', (data) => {
      this.handleRemoteSelectionClear(data);
    });
    this.socket.on('request-cursor-position', (data) => {
      if (this.codemirror && this.codemirror.getCodeMirror() && this.state.yourID && this.state.sessionid) {
        const cm = this.codemirror.getCodeMirror();
        const cursorPosition = cm.getCursor();
        const hasSelection = cm.somethingSelected() ? {
          anchor: cm.getCursor('anchor'),
          head: cm.getCursor('head')
        } : null;
        this.socket.emit('cursor-update', {
          sessionid: this.state.sessionid,
          position: cursorPosition,
          selection: hasSelection,
          activeTab: 'code'
        });
      }
    });

    this.socket.connect();
  }

  // Keep for backward compat — no longer needed since socket is created directly
  handleSocketReady(socket) {
    // No-op: socket is now initialized in initializeSocket()
  }

  // Handle remote cursor update
  handleRemoteCursorUpdate(data) {
    // Normalize payload (support socketID/socketId, tab/activeTab from different sources)
    const socketId = data.socketId ?? data.socketID;
    const activeTab = data.activeTab ?? data.tab ?? 'code';
    const position = data.position;

    // Don't show our own cursor
    if (socketId === this.state.yourID) {
      return;
    }

    // Update member active tab for header indicator
    if (activeTab) {
      this.setState((prev) => ({
        memberActiveTabs: { ...prev.memberActiveTabs, [socketId]: activeTab }
      }));
    }

    // Only show code cursor when remote user is on code tab (or activeTab omitted for backward compat)
    if (activeTab === 'diagram') {
      this.removeRemoteCursor(socketId);
      return;
    }

    if (!this.codemirror || !this.codemirror.getCodeMirror() || !socketId || !position) {
      if (process.env.NODE_ENV === 'development' && position) {
        console.debug('[remote-cursor] Skip: codemirror=', !!this.codemirror, 'socketId=', socketId, 'position=', position);
      }
      return;
    }

    // Use the color and name from the event data (sent by server) for consistency
    // Fallback to member lookup if data not provided
    const member = (data.color && data.name) ? {
      id: socketId,
      name: data.name,
      color: data.color
    } : this.state.members.find(m => m.id === socketId);

    if (!member || !member.color || !member.name) {
      if (process.env.NODE_ENV === 'development') {
        console.warn('[remote-cursor] Cannot display: missing member data', { socketId, hasColor: !!data.color, hasName: !!data.name, membersCount: this.state.members?.length });
      }
      return;
    }

    // Create a unique user identifier (name + color) to group tabs from the same user
    const userId = `${member.name}|${member.color}`;

    // If we already have a cursor for this user (from a different tab), remove it
    if (this.userCursors.has(userId)) {
      const oldSocketId = this.userCursors.get(userId);
      if (oldSocketId !== socketId && this.remoteCursors.has(oldSocketId)) {
        this.removeRemoteCursor(oldSocketId);
      }
    }

    // Update the mapping: this user is now represented by this socketId
    this.userCursors.set(userId, socketId);

    // Only update cursor display when position actually changed (avoids label flashing on periodic polls)
    const existing = this.remoteCursorPositions.get(socketId);
    const posEqual = existing?.position &&
      existing.position.line === position.line &&
      existing.position.ch === position.ch;
    if (posEqual) {
      return;
    }

    this.displayRemoteCursor(socketId, position, member);
  }

  // Get or create the overlay container for remote cursors (positioned absolutely, no layout impact)
  // Overlay is inside the sizer so it scrolls with content; charCoords are in sizer coordinate space
  getOrCreateRemoteCursorOverlay(cm) {
    if (this.remoteCursorOverlay && this.remoteCursorOverlay.parentNode) {
      return this.remoteCursorOverlay;
    }
    this.remoteCursorOverlay = null; // Was removed (e.g. by setValue); recreate
    const wrapper = cm.getWrapperElement();
    const sizer = wrapper.querySelector('.CodeMirror-sizer') || wrapper.querySelector('.CodeMirror-scroll');
    const parent = sizer || wrapper;
    if (!parent) return null;
    const overlay = document.createElement('div');
    overlay.className = 'remote-cursor-overlay';
    overlay.style.cssText = 'position:absolute;top:0;left:0;pointer-events:none;z-index:10;';
    parent.style.position = 'relative';
    parent.appendChild(overlay);
    this.remoteCursorOverlay = overlay;
    return overlay;
  }

  // Update overlay size to match scroll content (call on scroll/resize)
  updateRemoteCursorOverlaySize(cm) {
    if (!this.remoteCursorOverlay || !cm) return;
    const info = cm.getScrollInfo();
    if (info && info.width != null && info.height != null) {
      this.remoteCursorOverlay.style.width = info.width + 'px';
      this.remoteCursorOverlay.style.height = info.height + 'px';
    }
  }

  // Display remote cursor indicator - uses overlay so it never affects document layout
  displayRemoteCursor(socketId, position, member) {
    if (!this.codemirror || !this.codemirror.getCodeMirror()) {
      return;
    }

    const cm = this.codemirror.getCodeMirror();

    // Clamp position to document bounds (documents may differ between clients)
    const lineCount = Math.max(1, cm.lineCount());
    const clampedLine = Math.max(0, Math.min(position.line, lineCount - 1));
    const lineLength = cm.getLine(clampedLine) ? cm.getLine(clampedLine).length : 0;
    const clampedCh = Math.max(0, Math.min(position.ch, lineLength));
    position = { line: clampedLine, ch: clampedCh };

    // Remove existing cursor if any
    this.removeRemoteCursor(socketId);

    const overlay = this.getOrCreateRemoteCursorOverlay(cm);
    if (!overlay) return;

    this.updateRemoteCursorOverlaySize(cm);

    // Get pixel coordinates - cursor appears as overlay, never affects layout
    let coords;
    try {
      coords = cm.charCoords(position, 'local');
    } catch (e) {
      console.warn('[remote-cursor] charCoords failed:', e);
      return;
    }

    // Create cursor container - absolutely positioned at coords, no layout impact
    const cursorContainer = document.createElement('div');
    cursorContainer.className = 'remote-cursor-container';
    cursorContainer.style.cssText = `position:absolute;left:${coords.left}px;top:${coords.top}px;height:1.2em;width:8px;margin-left:-4px;pointer-events:auto;cursor:default;z-index:10;`;
    cursorContainer.setAttribute('data-socket-id', socketId);

    // Cursor line - thin vertical bar between characters
    const cursorEl = document.createElement('div');
    cursorEl.className = 'remote-cursor';
    cursorEl.style.cssText = `border-left:2px solid ${member.color};height:1.2em;width:0;position:absolute;left:2px;top:0;pointer-events:none;`;

    // Label with member name
    const labelEl = document.createElement('div');
    labelEl.className = 'remote-cursor-label';
    labelEl.textContent = member.name;
    labelEl.style.cssText = `background-color:${member.color};color:#fff;padding:2px 6px;font-size:11px;border-radius:3px;position:absolute;top:100%;margin-top:2px;left:0;white-space:nowrap;z-index:11;pointer-events:none;font-weight:500;box-shadow:0 2px 4px rgba(0,0,0,0.2);opacity:1;transition:opacity 0.2s ease;`;

    cursorContainer.appendChild(cursorEl);
    cursorContainer.appendChild(labelEl);

    cursorContainer.setAttribute('data-label-visible', 'true');
    const labelTimeout = setTimeout(() => {
      labelEl.style.opacity = '0';
      cursorContainer.setAttribute('data-label-visible', 'false');
    }, 2000);

    cursorContainer.addEventListener('mouseenter', () => {
      labelEl.style.opacity = '1';
    });
    cursorContainer.addEventListener('mouseleave', () => {
      if (cursorContainer.getAttribute('data-label-visible') === 'false') {
        labelEl.style.opacity = '0';
      }
    });

    if (!this.cursorLabelTimeouts) this.cursorLabelTimeouts = new Map();
    this.cursorLabelTimeouts.set(socketId, labelTimeout);

    overlay.appendChild(cursorContainer);
    this.remoteCursors.set(socketId, { element: cursorContainer });
    this.remoteCursorPositions.set(socketId, { position: { ...position }, member });

    // Update positions on scroll and document change
    if (!this.remoteCursorScrollHandler) {
      this.remoteCursorScrollHandler = () => this.updateRemoteCursorPositions();
      cm.on('scroll', this.remoteCursorScrollHandler);
    }
    if (!this.remoteCursorChangeHandler) {
      this.remoteCursorChangeHandler = () => this.updateRemoteCursorPositions();
      cm.on('change', this.remoteCursorChangeHandler);
    }

    if (process.env.NODE_ENV === 'development') {
      console.debug('[remote-cursor] Displayed', member.name, 'at', position);
    }
  }

  // Update all remote cursor positions (e.g. after scroll)
  updateRemoteCursorPositions() {
    if (!this.codemirror || !this.codemirror.getCodeMirror()) return;
    const cm = this.codemirror.getCodeMirror();
    this.remoteCursorPositions.forEach(({ position }, socketId) => {
      const entry = this.remoteCursors.get(socketId);
      if (!entry || !entry.element) return;
      try {
        const coords = cm.charCoords(position, 'local');
        entry.element.style.left = coords.left + 'px';
        entry.element.style.top = coords.top + 'px';
      } catch (e) { /* position may be invalid */ }
    });
    this.updateRemoteCursorOverlaySize(cm);
  }

  // Handle remote selection update
  handleRemoteSelectionUpdate(data) {
    if (!this.codemirror || !this.codemirror.getCodeMirror() || !data.socketId || !data.selection) {
      return;
    }

    // Don't show our own selection
    if (data.socketId === this.state.yourID) {
      return;
    }

    // Use the color and name from the event data (sent by server) for consistency
    // Fallback to member lookup if data not provided
    const member = data.color && data.name ? {
      id: data.socketId,
      name: data.name,
      color: data.color
    } : this.state.members.find(m => m.id === data.socketId);

    if (!member || !member.color || !member.name) {
      console.warn('Cannot display selection: missing member data', data);
      return;
    }

    this.displayRemoteSelection(data.socketId, data.selection, member);
  }

  // Display remote text selection
  displayRemoteSelection(socketId, selection, member) {
    if (!this.codemirror || !this.codemirror.getCodeMirror()) {
      return;
    }

    const cm = this.codemirror.getCodeMirror();

    // Remove existing selection if any
    this.removeRemoteSelection(socketId);

    try {
      // Normalize selection positions - ensure from < to for markText
      // CodeMirror's anchor/head can be in either order depending on selection direction
      let from, to;

      // Compare positions: if anchor comes before head, use as-is; otherwise swap
      const anchor = selection.anchor;
      const head = selection.head;

      // Compare line numbers first, then character positions
      if (anchor.line < head.line ||
        (anchor.line === head.line && anchor.ch < head.ch)) {
        // Normal selection (top-to-bottom, left-to-right)
        from = anchor;
        to = head;
      } else {
        // Reverse selection (bottom-to-top, right-to-left)
        from = head;
        to = anchor;
      }

      // Validate positions are within document bounds
      const lineCount = cm.lineCount();
      if (from.line < 0 || from.line >= lineCount || to.line < 0 || to.line >= lineCount) {
        console.warn('Selection position out of bounds:', { from, to });
        return;
      }

      const marker = cm.doc.markText(
        from,
        to,
        {
          className: 'remote-selection',
          css: `background-color: ${member.color}33;`,
          title: `${member.name}'s selection`
        }
      );

      this.remoteSelections.set(socketId, marker);
    } catch (e) {
      console.error('Error marking remote selection:', e);
    }
  }

  // Handle remote selection clear
  handleRemoteSelectionClear(data) {
    if (data.socketId) {
      this.removeRemoteSelection(data.socketId);
    }
  }

  // Re-apply all remote cursors (e.g. after setValue clears the document)
  reapplyRemoteCursors() {
    if (!this.codemirror || !this.codemirror.getCodeMirror()) return;
    const entries = Array.from(this.remoteCursorPositions.entries());
    entries.forEach(([socketId, { position, member }]) => {
      this.displayRemoteCursor(socketId, position, member);
    });
  }

  // Remove remote cursor
  removeRemoteCursor(socketId) {
    this.remoteCursorPositions.delete(socketId);
    if (this.remoteCursors.has(socketId)) {
      const { element } = this.remoteCursors.get(socketId);
      if (element && element.parentNode) {
        element.parentNode.removeChild(element);
      }
      this.remoteCursors.delete(socketId);
    }

    // Clear label timeout if it exists
    if (this.cursorLabelTimeouts && this.cursorLabelTimeouts.has(socketId)) {
      clearTimeout(this.cursorLabelTimeouts.get(socketId));
      this.cursorLabelTimeouts.delete(socketId);
    }
  }

  // Remove remote selection
  removeRemoteSelection(socketId) {
    if (this.remoteSelections.has(socketId)) {
      const marker = this.remoteSelections.get(socketId);
      if (marker) {
        marker.clear();
      }
      this.remoteSelections.delete(socketId);
    }
  }

  // Clean up all remote cursors
  cleanupRemoteCursors() {
    this.remoteCursors.forEach((value, socketId) => {
      this.removeRemoteCursor(socketId);
    });
    // Clear all label timeouts
    if (this.cursorLabelTimeouts) {
      this.cursorLabelTimeouts.forEach((timeout) => {
        clearTimeout(timeout);
      });
      this.cursorLabelTimeouts.clear();
    }
    // Remove overlay and scroll handler
    if (this.remoteCursorOverlay && this.remoteCursorOverlay.parentNode) {
      this.remoteCursorOverlay.parentNode.removeChild(this.remoteCursorOverlay);
      this.remoteCursorOverlay = null;
    }
    const cm = this.codemirror?.getCodeMirror?.();
    if (cm) {
      if (this.remoteCursorScrollHandler) {
        cm.off('scroll', this.remoteCursorScrollHandler);
        this.remoteCursorScrollHandler = null;
      }
      if (this.remoteCursorChangeHandler) {
        cm.off('change', this.remoteCursorChangeHandler);
        this.remoteCursorChangeHandler = null;
      }
    }
    // Clear user cursors mapping
    if (this.userCursors) {
      this.userCursors.clear();
    }
  }

  // Clean up all remote selections
  cleanupRemoteSelections() {
    this.remoteSelections.forEach((value, socketId) => {
      this.removeRemoteSelection(socketId);
    });
  }

  render() {
    initializeAnalytics();
    // eslint-disable-next-line  
    let usageStats = this.state.usage;
    // eslint-disable-next-line
    let codeSuggestion = this.state.code + this.state.codeSuggestion;
    const { line, ch } = this.state.cursorPosition;
    let codeSuggestionLength = this.state.codeSuggestion;
    return (
      <RemoveScroll>
        <React.Fragment>
          <Hotkeys
            keyName="command+enter,alt+s,command+i"
            onKeyDown={(keyName) => {
              if (keyName === "command+i") {
                this.toggleCompletion();
              } else if (keyName === "command+enter" || keyName === "alt+s") {
                this.onKeyDown(keyName);
              }
            }}
            onKeyUp={this.onKeyUp.bind(this)}
          >
            <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0" />
            <Header
              darkMode={this.props.darkMode}
              members={this.state.members}
              yourID={this.state.yourID}
              memberActiveTabs={this.state.memberActiveTabs}
              activeTab={this.state.activeTab}
              // style={{ background: "#282a36" }}
              extras={
                <div className="createdOn">
                  {this.state.createdon
                    ? `${this.state.createdon}`
                    : ""}
                </div>
              }
            />
            <TabBar
              activeTab={this.state.activeTab}
              onTabChange={this.setActiveTab.bind(this)}
              darkMode={this.props.darkMode}
              diagramCollaborationOn={this.state.diagramCollaborationOn}
              onDiagramCollaborationToggle={() => this.setDiagramCollaborationOn(!this.state.diagramCollaborationOn)}
            />
            {this.loginRender()}
            {this.toolTipRender()}
            <History darkMode={this.props.darkMode} />
            {/* Removed abuse warning - no longer limiting users */}
            {this.state.showShareModal && (
              <div className="share-modal-overlay" onClick={this.closeShareModal}>
                <div className="share-modal" onClick={(e) => e.stopPropagation()}>
                  <div className="share-modal-header">
                    <h3>🔗 Share Sandbox</h3>
                    <button className="share-modal-close" onClick={this.closeShareModal}>×</button>
                  </div>
                  <div className="share-modal-content">
                    <div className="share-link-section">
                      <label>Shareable Link:</label>
                      <div className="share-link-container">
                        <input
                          type="text"
                          value={this.state.shareLink}
                          readOnly
                          className="share-link-input"
                        />
                        <button
                          className="copy-link-btn"
                          onClick={this.copyToClipboard}
                        >
                          {this.state.copySuccess ? '✓ Copied!' : '📋 Copy'}
                        </button>
                      </div>
                    </div>
                    <div className="share-info">
                      <p>
                        {this.state.isPrivate ?
                          "🔒 Private sandbox - Only you can edit, others can view and fork" :
                          "🌐 Public sandbox - Anyone can view and fork"
                        }
                      </p>
                    </div>
                    {this.state.login && (
                      <div className="privacy-toggle-section">
                        <label>Privacy Setting:</label>
                        <div className="privacy-toggle-container">
                          <button
                            className={`privacy-toggle-btn ${!this.state.isPrivate ? 'active' : ''}`}
                            onClick={() => !this.state.isPrivate ? null : this.togglePrivacy()}
                            disabled={!this.state.isPrivate}
                          >
                            🌐 Public
                          </button>
                          <button
                            className={`privacy-toggle-btn ${this.state.isPrivate ? 'active' : ''}`}
                            onClick={() => this.state.isPrivate ? null : this.togglePrivacy()}
                            disabled={this.state.isPrivate}
                          >
                            🔒 Private
                          </button>
                        </div>
                        <p className="privacy-note">
                          {this.state.isPrivate ?
                            "Private sandboxes are only visible to you and can be shared with others for viewing." :
                            "Public sandboxes are visible to everyone and can be accessed by anyone with the link."
                          }
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
            <div
              className={`coding-tabs-wrapper ${this.state.whiteboardExtend ? "agent-panel-open" : ""}`}
              style={this.state.whiteboardExtend && this.state.agentPanelWidthPx
                ? { '--agent-panel-width': `${this.state.agentPanelWidthPx}px` }
                : undefined}
            >
              <div
                className={`tab-content-with-agent ${this.state.whiteboardExtend ? "agent-panel-open" : ""}`}
                style={this.state.whiteboardExtend && this.state.agentPanelWidthPx
                  ? { "--agent-panel-width": `${this.state.agentPanelWidthPx}px` }
                  : undefined}
              >
                {this.state.activeTab === "diagram" && (
                  <div className="diagram-layout-cell">
                    <div className="diagram-layout">
                      <div className="diagram-excalidraw-area">
                        <DiagramView
                          darkMode={this.props.darkMode}
                          sessionId={this.state.sessionid}
                          isPrivate={this.state.isPrivate}
                          socket={this.socket}
                          members={this.state.members}
                          yourID={this.state.yourID}
                          isCollaborating={this.state.diagramCollaborationOn}
                          onCollaborationChange={this.setDiagramCollaborationOn.bind(this)}
                          systemDesignInstructions={
                            this.state.interviewContext?.interviewType === "system-design"
                              ? this.state.interviewContext.content || this.state.interviewContext.instructions
                              : undefined
                          }
                        />
                      </div>
                    </div>
                  </div>
                )}
                {this.state.activeTab === "code" && (
                  <div className={this.state.whiteboardExtend === false ? "topMost-whiteboard" : "topMost"}>
                    <div className="coding">
                      <div className="topHalf">
                        <div className={this.state.whiteboardExtend === false ? "coding-page" : "coding-page-whiteboard"}>
                          {/* This is where the CODE EDITOR goes */}
                          <CodeMirror
                            ref={(r) => (this.codemirror = r)}
                            style={{ backgroundColor: this.props.darkMode === false ? '#282a36' : '#000' }}
                            className={this.props.darkMode === false ? "CodeMirror-theme code-mirror-container" : "CodeMirror-theme-dark code-mirror-container"}
                            value={this.state.code}
                            onChange={this.onChange}
                            options={{
                              theme: "dracula",
                              lineNumbers: true,
                              lineWrapping: true,
                              tabMode: "indent",
                              matchBrackets: true,
                              matchTags: true,
                              autoCloseTags: true,
                              autoCloseBrackets: true,
                              readOnly: false,
                              scrollbarStyle: "null",
                              mode: this.state.mode,
                              autofocus: true,
                              indentWithTabs: true,
                              smartIndent: true,
                              cursorBlinkRate: 530, // Make cursor blink at a visible rate
                              cursorHeight: 1, // Make cursor full height
                              cursorStyle: "line", // Use a line cursor
                              extraKeys: {
                                "Shift-Tab": this.handleShiftTab.bind(this),
                                "Cmd-Enter": (cm) => {
                                  this.runCode();
                                },
                                "Cmd-I": (cm) => {
                                  this.toggleCompletion();
                                },
                                "Esc": this.handleEscapeKey.bind(this)
                              }
                            }}
                            placeholder="this is the placeholder text"
                          />
                          {/* Language dropdown moved to eval section */}
                          <div
                            ref={this.aiCardRef}
                            className="aiCard"
                            onWheel={this.handleAiCardWheel}
                          >
                            {this.mapCards()}
                          </div>
                        </div>
                      </div>
                      <div className="lowerHalf">
                        <div className="lowerMenu evalSec">
                          {/* This is where the CODE EXECUTION happens */}
                          <Eval
                            code={this.state.code}
                            language_id={this.state.language_id}
                            sessionid={this.state.sessionid}
                            evalExtend={this.state.evalExtend}
                            timerExtend={this.state.timerExtend}
                            darkMode={this.props.darkMode}
                            toggleExtend={this.toggleExtend.bind(this)}
                            toggleTimer={this.toggleTimer.bind(this)}
                            toggleWhiteboard={this.toggleWhiteboard.bind(this)}
                            toggleOpenAI={this.toggleOpenAI.bind(this)}
                            toggleBorder={this.toggleBorder.bind(this)}
                            toggleCompletion={this.toggleCompletion.bind(this)}
                            openAiToggle={this.state.openAiToggle}
                            borderToggle={this.state.borderToggle}
                            completionToggle={this.state.completionToggle}
                            toggleFlanT5={this.toggleFlanT5.bind(this)}
                            flanT5Toggle={this.state.flanT5Toggle}
                            anthropicToggle={this.state.anthropicToggle}
                            GrokAIToggle={this.state.GrokAIToggle}
                            GeminiToggle={this.state.GeminiToggle}
                            toggleGrokAI={this.toggleGrokAI.bind(this)}
                            toggleGemini={this.toggleGemini.bind(this)}
                            toggleAnthropic={this.toggleAnthropic.bind(this)}
                            loading={this.state.loading}
                            token={this.state.token}
                            evalOutput={this.state.evalOutput}
                            compileOutput={this.state.compileOutput}
                            time={this.state.time}
                            memory={this.state.memory}
                            evalOutputDB={this.state.evalOutputDB}
                            runCode={this.runCode.bind(this)}
                            login={this.state.login}
                            whiteboardExtend={this.state.whiteboardExtend}
                            openShareModal={this.openShareModal.bind(this)}
                            languageOptions={this.state.language}
                            toggleLanguage={this.toggleLanguage.bind(this)}
                            currlang={this.state.currlang}
                          />
                        </div>
                        <div className="lowerMenu videoSec videoSec-spacer" aria-hidden="true" />
                      </div>
                    </div>
                  </div>
                )}
                {this.whiteboardRender()}
              </div>
              <div
                className={`shared-bottom-bar ${this.state.whiteboardExtend ? "agent-panel-open" : ""}`}
                style={this.state.whiteboardExtend && this.state.agentPanelWidthPx
                  ? { '--agent-panel-width': `${this.state.agentPanelWidthPx}px` }
                  : undefined}
              >
                <div className="diagram-bottom-spacer" aria-hidden="true" />
                <div className={`lowerMenu videoSec ${!this.state.whiteboardExtend ? "agent-closed" : ""}`}>
                  {this.state.sessionid !== null && (
                    <VideoChatLiveKit
                      sessionId={this.state.sessionid}
                      darkMode={this.props.darkMode}
                      userName={this.state.user?.displayName || undefined}
                      activeUsersCount={this.state.members ? this.state.members.length : 0}
                    />
                  )}
                  <ControlPanel
                    openAiToggle={this.state.openAiToggle}
                    toggleOpenAI={this.toggleOpenAI.bind(this)}
                    GrokAIToggle={this.state.GrokAIToggle}
                    toggleGrokAI={this.toggleGrokAI.bind(this)}
                    GeminiToggle={this.state.GeminiToggle}
                    toggleGemini={this.toggleGemini.bind(this)}
                    flanT5Toggle={this.state.flanT5Toggle}
                    toggleFlanT5={this.toggleFlanT5.bind(this)}
                    anthropicToggle={this.state.anthropicToggle}
                    toggleAnthropic={this.toggleAnthropic.bind(this)}
                    completionToggle={this.state.completionToggle}
                    toggleCompletion={this.toggleCompletion.bind(this)}
                    whiteboardExtend={this.state.whiteboardExtend}
                    toggleWhiteboard={this.toggleWhiteboard.bind(this)}
                    toggleBorder={this.toggleBorder.bind(this)}
                    openShareModal={this.openShareModal.bind(this)}
                  />
                </div>
                {this.state.whiteboardExtend && (
                  <div className="agent-panel-spacer" aria-hidden="true" />
                )}
              </div>
            </div>
          </Hotkeys>
        </React.Fragment>
      </RemoveScroll>);
  }
}

export default CodingPageWrapper;